import React, {Component} from 'react';
import {RouteComponentProps, withRouter} from "react-router-dom";
import {AccountService} from "repositories/AccountService";
import {LanguageService} from "language/LanguageService";
import {CategoryRepository} from "repositories/category/CategoryRepository";
import {AllPopupWrap} from "footer/Footer";
import {
  DownloadType,
  EmptyCommunityComment,
  emptyCreateUserDownloadRequest,
  emptyIDocGoodBadInfo,
  emptySsqDataDocument,
  emptyVersion,
  ICommunityComment,
  ICreatePostFeedback,
  ICreateUserDownloadRequest,
  ICreateUserShareRequest,
  IDocGoodBadInfo,
  IFile,
  IFileHover,
  IMyCheckDocGoodBad,
  ISsqDataDocMinInfo,
  ISsqDataDocument,
  IVersion,
  NO_VERSION_TAG,
  SsqDataRepository
} from "repositories/SsqDataRepository";
import CategoryStore, {ICategoryForSearch} from "repositories/category/CategoryStore";
import {RoleType} from "definitions/RoleType";
import {TargetType} from "definitions/TargetType";
import {CategoryType} from "definitions/CategoryType";
import {DocLanguageType} from "definitions/DocLanguageType";
import {getEncodedStringRemovedUnValidUrl, parseSanitize} from "util/commonUtils";
import {SsqImages} from "images/SsqImages";
import {getFileSize} from "util/fileSize";
import NotFoundPage from "NotFoundPage";
import styled from "styled-components";
import {fontFamilyBold, fontFamilyMedium, fontFamilyRegular} from "style/fonts";
import {EditorStyle} from "style/SsqEditorStyle";
import parse from "html-react-parser";

import clsx from "clsx";
import axios from "axios";
import {connect} from "react-redux";
import {IfLoginInfo} from "models/IfLoginInfo";
import {DocCommentInfo, IfDocCommentInfo,} from "models/IfSsqDataDocCommentEntity";

import {emptySocialSignupInfo, LoginService, SocialSignupInfo} from "login/LoginService";
import {LoginPopup} from 'header/LoginPopup';
import {SignupPopup} from "header/SignupPopup";
import {SignupSocialPopup} from "header/SignupSocialPopup";
import {TermsDetailPopup} from "header/TermsDetailPopup";
import {TermsDetailPrivatePopup} from "header/TermsDetailPrivatePopup";
import {SendVerifyEmailPopup} from "header/SendVerifyEmailPopup";
import {PasswordResetPopup} from "header/PasswordResetPopup";
import {SendPasswordResetEmailPopup} from "header/SendPasswordResetEmailPopup";
import {NotificationService} from "repositories/NotificationService";
import {PopReport} from "docwrite/popup/PopReport";
import svcs from "services";
import {FeedbackType} from "definitions/FeedbackType";
import {IfTagListEntity} from "models/IfTagListEntity";
import SimpleUserProfile from "communitypage/common/SimpleUserProfile";
import {docutil} from "util/docutil";
import {exposeCommunityLink} from "../CommunityExpose";
import {IfSvrConf} from "models/IfSvrConf";
import {langutil} from "language/langutil";
import CommunityPostInfo from "communitypage/common/CommunityPostInfo";
import ToastPopup from "productpage/ToastPopup";
import CommunityPostHoverText from "communitypage/common/CommunityPostHoverText";
import {helmetFormat, i18ntrans, tcommona} from "language/i18nkey";
import {getLangSuffix, HelmetTitleAndH1} from "ctls/common/HelmetTitleAndH1";
import {loginutil} from "util/loginutil";
import {DocType} from "definitions/DocType";
import {ssqutil} from "util/ssqutil";
import {ReqDelPopupWrap} from "docwrite/community/popup/ReqDelPopupWrap";
import {roleutil} from "util/roleutil";
import LoginFailPopup from "header/LoginFailPopup";
import {AllPopupOverlay, BoardViewContentsList, CommentWrap, TranPopupOverlay} from "style/CommonStyledComponents";
import {authutil} from 'util/authutil';
import {QnaPageAsideWrap} from "../qna/popup/QnaPageAsideWrap";
import img_icon_c_time from "images/common/icon_c_time.svg";
import img_icon_c_view from "images/common/icon_c_view.svg";
import img_icon_c_comment from "images/common/icon_comment.svg";

interface IBlogPagePopUpMatchParams {
  documentId: string;
  country?: string;
  lang?: string;
}

export interface LoginInputValues {
  id: string;
  password: string;
}

interface Props extends RouteComponentProps<IBlogPagePopUpMatchParams, any> {
  accountService: AccountService;
  languageService: LanguageService;
  categoryRepository: CategoryRepository;
  ssqDataRepository: SsqDataRepository;
  categoryStore: CategoryStore;
  loginInfo: IfLoginInfo;
  svrConf: IfSvrConf;


  loginService: LoginService;
  notificationService: NotificationService;

  openToast?: (type: string) => void;

  displayLoginPopup: Function;
  displayLoginFailPopup: Function;
}

interface State {
  selectedComment: ICommunityComment
  selectedDocumentDetail: ISsqDataDocument
  descriptionParsedResult: any
  selectedVersionItem: IVersion
  clickCount: number
  productCategories: ICategoryForSearch[],
  industryCategories: ICategoryForSearch[],
  applicationLoadCategories: ICategoryForSearch[]
  isMounted: boolean
  feedbackGood: boolean
  feedbackBad: boolean
  feedbackComment: string
  docGoodBadInfo: IDocGoodBadInfo

  modifyPost: boolean
  modifyReview: boolean
  reportReview: boolean
  modifyPostClick: boolean
  modifyReviewClick: boolean
  reportReviewClick: boolean

  comment: string
  commentUpdate: string
  commentList: Array<IfDocCommentInfo>


  loginInputValues: LoginInputValues
  showLoginPopup: boolean
  isLoggedIn: boolean
  showLoginFailPopup: boolean
  showSignupPopup: boolean
  showSendVerifyEmailPopup: boolean
  signupEmail: string
  showSignupSocialPopup: boolean
  socialSignupInfo: SocialSignupInfo
  showPasswordResetPopup: boolean


  showUserPopup: boolean
  isLoginPopup: boolean
  isLoggedInAdmin: boolean
  isDisplaySetting: boolean
  loggedInNickname: string
  resetPasswordEmail: string
  termsType: string
  showSendPasswordResetEmailPopup: boolean
  showTermsDetailPopup: boolean
  showTermsDetailPrivatePopup: boolean

  docGood: boolean;
  docBad: boolean;
  docGoodCnt: number;
  docBadCnt: number;
  bookMarkClick: boolean;

  tags: Array<IfTagListEntity>,
  ssqEditorList: Array<String>

  isMobile: boolean;
  seq: number,
  toastType: string,

  goodHover: boolean,
  badHover: boolean,
  bookMarkHover: boolean,
  shareHover: boolean,
  moreHover: boolean,

  rndKr: boolean,
  rndEn: boolean,
  rndEnUs: boolean,
}


class BlogPagePopup extends Component<Props, State> {
  popReport: React.RefObject<PopReport>;
  outSideClick: React.RefObject<HTMLInputElement>;
  outSideClickPost: React.RefObject<HTMLInputElement>;
  modifyCommentRef: React.RefObject<HTMLTextAreaElement>;
  saveCommentRef: React.RefObject<HTMLTextAreaElement>;
  private readonly refPopDelReq: React.RefObject<{
    show: ({doc: ISsqDataDocumentAdminPopup}) => Promise<any>
  }>;

  constructor(props: Props) {
    super(props);
    this.state = {
      selectedComment: EmptyCommunityComment,
      selectedDocumentDetail: emptySsqDataDocument,
      descriptionParsedResult: undefined,
      selectedVersionItem: emptyVersion,
      clickCount: 0,
      productCategories: [],
      industryCategories: [],
      applicationLoadCategories: [],
      isMounted: false,
      feedbackGood: false,
      feedbackBad: false,
      feedbackComment: "",
      docGoodBadInfo: emptyIDocGoodBadInfo,

      modifyPost: false,
      modifyReview: false,
      reportReview: false,
      modifyPostClick: true,
      modifyReviewClick: true,
      reportReviewClick: true,

      comment: "",
      commentUpdate: "",
      commentList: [],


      loginInputValues: {
        id: "",
        password: "",
      },
      showLoginPopup: false,
      isLoggedIn: false,
      showLoginFailPopup: false,
      showSignupPopup: false,
      showSendVerifyEmailPopup: false,
      signupEmail: "",
      showSignupSocialPopup: false,
      socialSignupInfo: emptySocialSignupInfo,
      showPasswordResetPopup: false,

      showUserPopup: false,
      isLoginPopup: false,
      isLoggedInAdmin: false,
      isDisplaySetting: false,
      loggedInNickname: "",
      resetPasswordEmail: "",
      termsType: "",
      showSendPasswordResetEmailPopup: false,
      showTermsDetailPopup: false,
      showTermsDetailPrivatePopup: false,

      docGood: false,
      docBad: false,
      docGoodCnt: 0,
      docBadCnt: 0,
      bookMarkClick: false,

      tags: [],
      ssqEditorList: [],

      isMobile: false,
      seq: 0,
      toastType: '',

      goodHover: false,
      badHover: false,
      bookMarkHover: false,
      shareHover: false,
      moreHover: false,

      rndEn: false,
      rndEnUs: false,
      rndKr: false,

    };

    this.popReport = React.createRef();
    this.refPopDelReq = React.createRef();

    this.outSideClick = React.createRef();
    this.outSideClickPost = React.createRef();

    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleClickOutsidePost = this.handleClickOutsidePost.bind(this);

    this.modifyCommentRef = React.createRef();
    this.saveCommentRef = React.createRef();
  }

  async setLoggedInStatus() {
    let isLoggedIn = false;
    let isLoggedInAdmin = false;
    let isDisplaySetting = false;
    let loggedInNickname = "";
    if (await this.props.accountService.isLoggedInAsAdmin()) {
      isLoggedIn = true;
      isLoggedInAdmin = true;
      isDisplaySetting = await this.props.accountService.isAllowedAdminForSettingMenu();
      loggedInNickname = await this.props.accountService.getLoggedInNickname();

    } else if (await this.props.accountService.isLoggedIn()) {
      isLoggedIn = true;
      loggedInNickname = await this.props.accountService.getLoggedInNickname();
    }

    this.setState({
      isLoggedIn,
      isLoggedInAdmin,
      isDisplaySetting,
      loggedInNickname,

    });
  }

  async componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
    if (this.props.loginInfo?.userId && this.props?.loginInfo?.userId !== prevProps?.loginInfo?.userId) {
      this.getMyCheckDocGoodBad({
        docId: Number(this.props.match.params.documentId),
        userId: this.props.loginInfo?.userId
      }).then(res => null);
      this.initPage().then(() => null);
    }

    // 로그인변경시, 또는, document변경시.
    if (this.props.loginInfo?.apires !== prevProps?.loginInfo?.apires ||
      this.state?.selectedDocumentDetail?.id !== prevState?.selectedDocumentDetail?.id) {
      if (this.state?.selectedDocumentDetail?.id && loginutil.fetched(this.props.loginInfo)) {
        //const exposelanguage = this.state?.selectedDocumentDetail?.exposeSiteLanguage || null;
        await this.verifyUserRole(loginutil.getrole(this.props.loginInfo), this.props.loginInfo?.userRoles);
      }
    }


    if (this.props.location.pathname !== prevProps.location.pathname && this.state.showUserPopup) {
      this.setState({
        showUserPopup: false
      });
    }
    if (this.state.isLoginPopup && !this.state.showLoginPopup) {
      this.setState({
        showLoginPopup: true
      });
    }
    if (this.modifyCommentRef.current) {
      this.commentModifyAutoSize();
    }
    if (this.saveCommentRef.current) {
      this.commentSaveAutoSize();
    }
  }

  async setCategoryStore() {
    if (this.props.categoryStore.allCategories.length === 0) {
      let language = this.props.languageService.getLanguage();
      const allCategories = await this.props.categoryRepository.getExposedCategories(language);
      await this.props.categoryStore.setAllCategories(allCategories);
    }
  }

  async componentDidMount() {
    if (!langutil.isCountryLangUrl()) { // url에 국가/언어가 없으면.
      const docId = this.props.match.params.documentId;
      const minInfo: ISsqDataDocMinInfo = (await axios.get('/api/guest/ssqData/docmininfo/' + docId)).data;
      document.location.href = langutil.getCountryLangUrl(minInfo.exposeSiteLanguage);
      return; // 다음으로 진행하지 않도록.
    }

    if (window.innerWidth < 1199)
      this.setState({isMobile: true});
    else
      this.setState({isMobile: false});

    await exposeCommunityLink(this.props.match.params.documentId);
    await this.setCategoryStore();

    document.addEventListener('mousedown', this.handleClickOutside);
    document.addEventListener('mouseup', this.handleClickOutsidePost);

    await this.initPage();
    this.checkAdminRnd();

    if (this.state.selectedDocumentDetail.docType == "RND_NOTI") {
      document.getElementById("helmetTitle").innerText += " - " +
        helmetFormat([this.state.selectedDocumentDetail.docTitle, ' - '], 'I18N_COMMON_TIT_RND', [getLangSuffix()]);
    } else {
      document.getElementById("helmetTitle").innerText += " - " +
        helmetFormat([this.state.selectedDocumentDetail.docTitle, ' - '], 'I18N_COMMON_TIT_TECHLOG', [getLangSuffix()]);
    }
  }

  async initPage() {

    //await this.props.accountService.getLoggedInAuthority().then(response => this.verifyUserRole(response));

    await this.updateClickCount();
    await this.getDocumentDetail();
    await this.setLoggedInStatus();


    await this.props.ssqDataRepository.addClickCount(this.state.selectedDocumentDetail.id);
    await this.getCountDocGoodBad(this.state.selectedDocumentDetail.id);
    //await this.props.accountService.isLoggedIn().then(response => this.setState({isLogin: response}));


    // 문서 태그 리스트 호출
    axios.get('/api/guest/ssqData/doctaglist/taggrplist', {
      params: {
        docId: this.state.selectedDocumentDetail.id,
        lang: this.props.languageService.getLanguage()
      }
    }).then((res) => {
      this.setState({tags: res?.data || []});
    });

    /* 로그인 사용자가 해당 문서를 북마크 했는지 확인 */
    axios.post(`/api/guest/ssqData/bookmark/check`, {
      userId: this.props.loginInfo?.userId,
      docId: this.state.selectedDocumentDetail.id
    }).then(response => {
      if (response.data) {
        this.setState({bookMarkClick: response.data});
      }
    });
    await this.getMyCheckDocGoodBad({
      docId: Number(this.props.match.params.documentId),
      userId: this.props.loginInfo?.userId
    });
    await this.getCountDocGoodBad(this.state.selectedDocumentDetail.id);

    //const loggedInAuthority = await this.props.accountService.getLoggedInAuthority();
    axios.get('/api/guest/ssqData/doctaglist/taggrplist', {
      params: {
        docId: this.state.selectedDocumentDetail.id,
        lang: this.state.selectedDocumentDetail.exposeSiteLanguage
      }
    }).then((res) => {
      this.setState({tags: res?.data || []});
    });

    this.setState({isMounted: true,});

    console.log("initpage After ", this.state, this.props);
  }

  async verifyUserRole(loginAuth: string, userRole: string) {
    if (this.props.svrConf.iscrawler) {
      console.log("crawler useragent : ", this.props.svrConf.userAgent);
      return;
    }
    const dispTarget = this.state.selectedDocumentDetail.displayTarget;
    const pathname = this.props.history.location.pathname;
    const {country, lang} = langutil.splitLangCode(this.props.languageService.lang());
    if (loginAuth === RoleType.ROLE_ANONYMOUS && dispTarget === TargetType.LOGIN) {
      this.props.history.push(`/${country}/${lang}/requireMemberLogin`, pathname);
    } else if ([RoleType.ROLE_ANONYMOUS, RoleType.ROLE_MEMBER].includes(loginAuth) && dispTarget === TargetType.EMPLOYEE) {
      this.props.history.push(`/${country}/${lang}/requireEmployeeLogin`, pathname);
    } else if ([RoleType.ROLE_ANONYMOUS, RoleType.ROLE_MEMBER].includes(loginAuth) && dispTarget === TargetType.PARTNER) {
      !roleutil.hasPartnerChecks(this.props.loginInfo.userId, this.state?.selectedDocumentDetail?.exposeSiteLanguage)
        .then((hasPartner) => {     //파트너계정 + 국가 확인
          if (!hasPartner) {
            this.props.history.push(`/${country}/${lang}/requirePartnerLogin`, pathname);
          }
        });
    }

    // 로그인 확인 에러발생시 ----------------

    //정상적인 케이스는 페이지 보여주고,,,
    if ((loginAuth === RoleType.ROLE_ANONYMOUS && dispTarget === TargetType.GUEST)
      || (loginAuth === RoleType.ROLE_MEMBER && (dispTarget === TargetType.GUEST) || (dispTarget === TargetType.LOGIN))
      || (loginAuth === RoleType.ROLE_ADMIN && (dispTarget === TargetType.GUEST) || (dispTarget === TargetType.LOGIN) || (dispTarget === TargetType.EMPLOYEE) || (dispTarget === TargetType.PARTNER))
    ) {
      // 페이지 보여주고,,,
    }
    // 로그인 확인 에러발생시
    else {
      this.props.history.push(`/${country}/${lang}/requireMemberLogin`, pathname);
    }
  }

  // 오른쪽 사이드 스크롤 이벤트 -- 송지하
  asideScrollEvent() {
    let count = document.querySelector(".solution-list").children.length;
    let ssqEditor_li = [];
    let solution_li = [];
    for (let i = 0; i < count; i++) {
      let class_name = document.querySelector(".solution-list").children[i].id;
      // if (class_name != "sol-download") {
      solution_li.push(class_name);
      ssqEditor_li.push(class_name.substring(4));
      // }
    }
    this.setState({ssqEditorList: ssqEditor_li});
    document.querySelector(`#` + solution_li[0])?.classList.add("on");

    window.addEventListener('scroll', (e) => {
      let scrollTop = window.pageYOffset;
      let innerHeight = window.innerHeight;
      let scrollHeight = document.querySelector("body").scrollHeight;
      // 스크롤 끝났을 시에는 오른쪽상단목록 클릭했을 때 색변화만 줌
      if (scrollTop + innerHeight + 5 >= scrollHeight) {
        ssqEditor_li.forEach((cid) => {
          if (document.querySelector(`#sol-` + cid)?.classList.value.indexOf("click") > -1) {
            ssqEditor_li.forEach((cid) => document.querySelector(`#sol-` + cid)?.classList.remove("on"));
            document.querySelector(`#sol-` + cid)?.classList.add("on");
            // document.querySelector(`#sol-` + cid)?.classList.remove("click")
            // this.state.ssqEditorList.forEach((cid) => document.querySelector(`#sol-` + cid)?.classList.remove("click"));
          }

        });
        return;
      }
      ssqEditor_li.forEach((cls, i) => {
        let targetElement_1 = (cls == "download" ? document.querySelector(`#solution-download-bookmark`) : document.querySelector(`#` + cls));
        let targetElement_2 = document.querySelector(`#` + ssqEditor_li[i - 1]);
        let location_1 = targetElement_1?.getBoundingClientRect().y || 0 - 70;  // 현재 값 위치
        let location_2 = targetElement_2?.getBoundingClientRect().y || 0 - 70;  // 앞의 값 위치
        if (location_2 < 20 && location_1 < (window.innerHeight / 5)) { // solution-list의 앞 영역 제목이 화면에서 사라지고 해당 영역의 제목이 화면의 1/5이 되는 부분에 진입하면 on 추가
          ssqEditor_li.forEach((cid) => document.querySelector(`#sol-` + cid)?.classList.remove("on"));
          // document.querySelector(`#sol-download`)?.classList.remove("on");
          document.querySelector(`#sol-` + cls)?.classList.add("on");
          this.state.ssqEditorList.forEach((cid) => document.querySelector(`#sol-` + cid)?.classList.remove("click"));
        }

      });
    });
  }

  // ! -- 오른쪽 사이드 스크롤 이벤트 -- 송지하

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside(e: MouseEvent) {
    (this.state.commentList).map((ele) => {
      ele.reportReview = false;
      ele.modifyReview = false;
    });
  }

  handleClickOutsidePost(e: MouseEvent) {
    if (this.outSideClickPost.current && !this.outSideClickPost.current.contains(e.target as Node)) {
      this.setState({modifyPost: false});
    }
  }

  /*댓글 조회*/
  async getComments(docId) {
    return axios.get('/api/guest/ssqData/doccomment/list', {params: {docId}});
  }

  async getDocumentDetail() {
    let documentDetail = await this.props.ssqDataRepository.getSsqDataByDocumentId(Number(this.props.match.params.documentId));
    this.setStateCategories(documentDetail.categories);

    const docType = documentDetail?.docType;
    if (!authutil.isMatchUrlDocType(docType, this.props.location.pathname)) {
      const prefix = langutil.countryLangPrefix(this.props.location.pathname);
      document.location.href = prefix + "/404";
      return;
    }


    const pathname = this.props.location.pathname;
    if (authutil.isRnd(this.props.location.pathname)) {
      if (!loginutil.iswels(this.props.loginInfo) || !roleutil.hasRole("RND", this.props.loginInfo?.userRoles)) {
        this.props.history.push(`/requireEmployeeLogin`, pathname);
      }
    }
    /*문서 번호 확인 후 댓글 불러옴*/
    const comments = await this.getComments(documentDetail.id);
    console.log("===============comments ", comments);

    let selectedDocumentDetail = emptySsqDataDocument;
    let selectedVersionItem = emptyVersion;

    if (documentDetail && documentDetail.id) {
      selectedDocumentDetail = documentDetail;
    }

    if (documentDetail.versions.length > 0) {
      selectedVersionItem = documentDetail.versions[0];
    }

    let descriptionParsedResult = ssqutil.toarray(parse(documentDetail.description));
    descriptionParsedResult = this.setTitleTagsForBookmark(descriptionParsedResult);

    const clickCount = documentDetail.clickCount;

    this.setState({
      commentList: comments.data,
      selectedDocumentDetail,
      descriptionParsedResult,
      selectedVersionItem,
      clickCount,
    });
    // 오른쪽 사이드 스크롤 이벤트 -- 송지하
    this.asideScrollEvent();
    // ! -- 오른쪽 사이드 스크롤 이벤트 -- 송지하
  }

  setStateCategories(categories: number[]) {
    let productCategories = categories
      .map(categoryId =>
        this.props.categoryStore.getCategorySearchItemByIdAndType(categoryId, CategoryType.PRODUCT.toString())
      ).filter((category) => category.categoryId !== 0)
      .sort(
        (a, b) => {
          if (a.parentsCategory < b.parentsCategory) {
            return -1;
          }
          if (a.parentsCategory > b.parentsCategory) {
            return 1;
          }
          return 0;
        }
      );

    let industryCategories = categories
      .map(categoryId =>
        this.props.categoryStore.getCategorySearchItemByIdAndType(categoryId, CategoryType.INDUSTRY.toString())
      ).filter((category) => category.categoryId !== 0);
    let applicationLoadCategories = categories
      .map(categoryId =>
        this.props.categoryStore.getCategorySearchItemByIdAndType(categoryId, CategoryType.APPLICATION_LOAD.toString())
      ).filter((category) => category.categoryId !== 0);

    this.setState({
      productCategories,
      industryCategories,
      applicationLoadCategories
    });
  }

  /*기술블로그 전체 언어*/
  getTranslation(key: string): string {
    this.props.languageService.setNamespace("I18N_NAMESPACE_COMMUNITY_PAGE");
    return this.props.languageService.getTranslationByKey(key) || "";
  }

  /*신고하기 팝업창 언어*/
  getReportTrans(key: string): string {
    svcs.svcLang.setNamespace("I18N_NAMESPACE_ADMIN_PAGE");
    return svcs.svcLang.getTranslationByKey(key) || "";
  }

  async updateClickCount() {
    const patchClickCountResponse = await this.props.ssqDataRepository.addClickCount(Number(this.props.match.params.documentId));
    this.setState({clickCount: patchClickCountResponse.updatedClickCount});
  }

  async updateDownloadCount(fileId: number) {
    await this.props.ssqDataRepository.addDownloadCount([fileId]);
  }

  getLanguageString(fileLang: string): string {
    switch (fileLang) {
      case DocLanguageType.ALL:
        return this.getTranslation("I18N_FILE_LANG_ALL");
      case DocLanguageType.KO:
        return this.getTranslation("I18N_FILE_LANG_KO");
      case DocLanguageType.EN:
        return this.getTranslation("I18N_FILE_LANG_EN");
      case DocLanguageType.ETC:
        return this.getTranslation("I18N_FILE_LANG_ETC");
      default:
        return "-";
    }
  }

  copyToClipboardCurrentUrl() {
    const trans = this.getTranslation.bind(this);

    if (!document.queryCommandSupported("copy")) {
      //return alert("복사 기능이 지원되지 않는 브라우저입니다.");
      return alert(trans('I18N_BROWSER_DOES_NOT_SUPPORT'));
    }

    let dummy = document.createElement("input");
    let text = window.location.href;

    document.body.appendChild(dummy);
    dummy.value = text;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);

    //window.alert("현재 웹페이지의 주소(URL)가 클립보드에 복사되었습니다.");
    //window.alert(trans('I18N_URL_COPIED_TO_CLIPBOARD'));
  }

  setTitleTagsForBookmark(parsedResult: any) {
    if (parsedResult) {
      return parsedResult.map((element: any, index: number) => {
          if (element && element.type && (element.type === "h1" || element.type === "h2" || element.type === "h3")) {
            console.log(`#${element.type}-${index}`);
            let elementCopy = {
              ...element,
              props: {
                ...element.props,
                id: `${element.type}-${index}`
              }
            };
            return elementCopy;
          } else {
            return element;
          }
        }
      );
    }
  }

  getBookmarkedContentsList() {
    // id값 추가 -- 송지하
    return this.state.descriptionParsedResult && this.state.descriptionParsedResult.map((element: any, index: number) => {
      if (element && element.type && element.type === "h1") {
        return <h1 key={index} id={"sol-" + element.type + "-" + index}>
          <button onClick={() => {
            this.onClickContentsItem(element, index);
          }}>{element.props.children}</button>
        </h1>;
      } else if (element && element.type && element.type === "h2") {
        return <h2 key={index} id={"sol-" + element.type + "-" + index}>
          <button onClick={() => {
            this.onClickContentsItem(element, index);
          }}>{element.props.children}</button>
        </h2>;
      } else if (element && element.type && element.type === "h3") {
        return <h3 key={index} id={"sol-" + element.type + "-" + index}>
          <button onClick={() => {
            this.onClickContentsItem(element, index);
          }}>{element.props.children}</button>
        </h3>;
      }
    }) || <></>;
    // !-- id값 추가 -- 송지하
  }

  async postUserDownloadByFile(downloadFile: IFile) {
    let createUserDownloadRequest: ICreateUserDownloadRequest = {
      ...emptyCreateUserDownloadRequest,
      documentId: this.state.selectedDocumentDetail.id,
      docTitle: this.state.selectedDocumentDetail.docTitle,
      docType: this.state.selectedDocumentDetail.docType,
      downloadType: DownloadType.FILE,
      fileKey: downloadFile.fileKey,
      blobUrlForLargeFile: downloadFile.blobUrlForLargeFile,
      fileName: downloadFile.fileName,
      updateTime: new Date(),
    };

    await this.props.ssqDataRepository.postUserDownload(createUserDownloadRequest);
  }

  isClickedFeedback() {
    return this.state.feedbackBad || this.state.feedbackGood;
  }

  /*오른쪽 사이드 부분*/
  renderBlogPageAside() {
    return <aside className="community-view-aside">
      <div className="aside-content">
        <BlogPageAside>
          <QnaPageAsideWrap documentId={this.state.selectedDocumentDetail.id}
            doLogin={() => this.setState({showUserPopup: false, showLoginPopup: true})}
            loginInfo={this.props.loginInfo}/>
          <BoardViewContentsList className="solution-list" id="print-index-area">
            {this.getBookmarkedContentsList()}
            {this.state.selectedVersionItem.files.length > 0 &&
              <h1 id={"sol-download"}>
                <button onClick={() => {
                  let targetElement = document.querySelector(`#solution-download-bookmark`);
                  window.scrollTo({top: 0});
                  window.scrollTo({top: (targetElement?.getBoundingClientRect().y || 0)});
                  /* 클릭 시 오른쪽 상단 class click 추가-- 송지하 */
                  this.state.ssqEditorList.forEach((cid) => document.querySelector(`#sol-` + cid)?.classList.remove("click"));
                  document.querySelector(`#sol-download`)?.classList.add("click");
                  /* !-- 클릭 시 오른쪽 상단 class click 추가 -- 송지하 */
                }}>{this.getTranslation("I18N_SOLUTION_DOWNLOAD")}</button>
              </h1>}

          </BoardViewContentsList>

          {/*사이드 하단 피드백 부분*/}

          <ToastPopup languageService={this.props.languageService} loginInfo={this.props.loginInfo}
            seq={this.state.seq}
            type={this.state.toastType}
          ></ToastPopup>
        </BlogPageAside>
      </div>
    </aside>;
  }

  /*하단 문서 다운로드 부분*/
  renderBlogPageDownLoad() {
    return <div className="view-footer">
      <div className="content-download" id={"solution-download-bookmark"}>
        <p className="title">{this.getTranslation("I18N_SOLUTION_DOWNLOAD")}</p>
        {this.state.selectedVersionItem.version !== NO_VERSION_TAG &&
          <div className={"accordion-version"}>
            <div
              className={"version-tit"}>{this.getTranslation("I18N_DOC_COL_VERSION")} {this.state.selectedVersionItem.version}
            </div>
            <div
              className={"version-desc"}>{parseSanitize(this.state.selectedVersionItem.versionDescription)}</div>
          </div>
        }
        {this.state.selectedVersionItem.files.map((file: IFileHover, index) => {
          let fileDownloadUrl: string = `/uploads/${file.fileKey}/${getEncodedStringRemovedUnValidUrl(file.fileName)}`;
          if (file.blobUrlForLargeFile !== null && file.blobUrlForLargeFile !== undefined && file.blobUrlForLargeFile !== "") {
            fileDownloadUrl = ssqutil.getBlobUrlForLargeFile(file.blobUrlForLargeFile);
          }
          return <>
            <ul className="down-list">
              <li>
                <button className="down-title" onClick={async () => {
                  await this.updateDownloadCount(file.id);
                  await this.postUserDownloadByFile(file);
                }}>
                  <a aria-label={`download-${index}`}
                    href={(fileDownloadUrl)}
                    target="_blank"
                    rel="noopener noreferrer">
                    {file.fileName}</a>
                </button>
                <div className={"down-icon"}
                  onMouseEnter={(e) => {
                    e.stopPropagation();
                    file.downloadHover = true;
                    this.setState({selectedVersionItem: {...this.state.selectedVersionItem}});
                  }}
                  onMouseLeave={(e) => {
                    e.stopPropagation();
                    file.downloadHover = false;
                    this.setState({selectedVersionItem: {...this.state.selectedVersionItem}});
                  }}
                  onClick={async () => {
                    await this.updateDownloadCount(file.id);
                    await this.postUserDownloadByFile(file);
                  }}>
                  <a aria-label={`download-${index}`}
                    href={(fileDownloadUrl + "?type=attachment")}
                    target="_blank"
                    rel="noopener noreferrer"
                  ><img alt={"download_icon.svg"} src={SsqImages.common.icon.downloadImg()}/></a>
                  {file.downloadHover && <CommunityPostHoverText type={'download'}/>}
                </div>
                <ul className="file-info">
                  <li>{this.getLanguageString(file.fileLang)}</li>
                  <li>{getFileSize(file.fileSize)}</li>
                  {/*<li>{this.getTranslation("I18N_DOC_DOWNLOAD_COUNT")} <span className="count">{file.downloadCount}</span></li>*/}
                </ul>
              </li>
            </ul>
          </>;
        })
        }
      </div>
    </div>;
  }

  /*하단 댓글 부분*/
  renderBlogPageComment() {
    /*console.log("renderBlogPageComment ", this.state.commentList);*/

    return <>
      <BlogPagePopupTop>
        {(this.state.commentList || []).map((ele) => <div key={ele.docCommentId} className="review-content">

          <div className="review-content-item">
            <div className="review-flex">
              <div className="right">
                <ul className="comment-box">
                  <SimpleUserProfile userId={ele.writerId}
                    displayLoginPopup={this.props.displayLoginPopup}/>
                </ul>
                <span className="comment-content" style={{display: ele.showInput ? 'none' : ''}}>
                  {ele.commentCnts}
                </span>
                <ul className="comment-box">
                  <li className="c-time">{ele.showInput == true ? '' : docutil.diffTime((ele.updtDt))}
                  </li>
                </ul>


                {this.props.loginInfo.userId === ele.writerId ?
                  <div className="list-modify-body" ref={this.outSideClick}>
                    {!ele.showInput ?
                      <button className="btn-list-modify" onClick={() => {
                        ele.modifyReview = !ele.modifyReview;
                        this.setState({commentList: this.state.commentList.slice()});
                      }}>
                      </button>
                      : ele.modifyReview = false
                    }
                    {!ele.showInput ?
                      <div className={clsx("modify-item-body")}
                        style={{display: ele.modifyReview ? 'inline-block' : ''}}>

                        <button className={clsx("modify-btn modify")}
                          onClick={() => {
                            ele.showInput = true;
                            ele.modifyReview = !ele.modifyReview;
                            this.setState({commentList: this.state.commentList.slice()});
                          }}
                        >{this.getTranslation("I18N_COMMUNITY_MODIFY")}
                        </button>

                        <button className="modify-btn modify"
                          onClick={() => {
                            console.log("this.state.dodelete ----", ele.docCommentId);
                            this.handleClick('deleteReview', ele.docCommentId);
                          }}
                        >{this.getTranslation("I18N_COMMUNITY_DELETE")}
                        </button>
                      </div>
                      : ele.modifyReview = false
                    }
                  </div>
                  :
                  this.props.loginInfo.allowAdminKoKr || this.props.loginInfo.allowAdminEn || this.props.loginInfo.allowAdminEnUs === true ?
                    <div className="list-modify-body" ref={this.outSideClick}>
                      {!ele.showInput ?
                        <button className="btn-list-modify" onClick={() => {
                          ele.modifyReview = !ele.modifyReview;
                          this.setState({commentList: this.state.commentList.slice()});
                        }}>
                        </button>
                        : ele.modifyReview = false
                      }
                      {!ele.showInput ?
                        <div className={clsx("modify-item-body")}
                          style={{display: ele.modifyReview ? 'inline-block' : ''}}>

                          <button className={clsx("modify-btn modify")}
                            onClick={() => {
                              ele.reportReview = false;
                              ele.modifyReview = false;
                              this.handleClick('reportReview', ele);
                            }}>{this.getTranslation("I18N_COMMUNITY_COMMENT_REPORT")}
                          </button>

                          <button className="modify-btn modify"
                            onClick={() => {
                              console.log("this.state.dodelete ----", ele.docCommentId);
                              ele.modifyReview = !ele.modifyReview;
                              this.handleClick('deleteReview', ele.docCommentId);
                            }}
                          >{this.getTranslation("I18N_COMMUNITY_DELETE")}
                          </button>

                        </div>
                        : ele.modifyReview = false
                      }
                    </div>
                    :
                    <div className="list-modify-body" ref={this.outSideClick}>
                      <button className="btn-list-modify" onClick={() => {
                        ele.reportReview = !ele.reportReview;
                        this.setState({commentList: this.state.commentList.slice()});
                      }}></button>

                      <div className={clsx("modify-item-body")}
                        style={{display: ele.reportReview ? 'inline-block' : ''}}>

                        <button className={clsx("modify-btn notify modify")}
                          onClick={() => {
                            ele.reportReview = false;
                            this.handleClick('reportReview', ele);
                          }}>{this.getTranslation("I18N_COMMUNITY_COMMENT_REPORT")}
                        </button>
                      </div>
                    </div>
                }

              </div>

              <div className={"inner-review-modify"}>
                {ele.showInput ? <div className={clsx("review-input", this.state.isMobile ? "on" : "modify")}
                    onClick={() => {
                      ele.modifyReview = !ele.modifyReview;
                    }}>
                    <textarea rows={1} name=""
                      placeholder={this.getTranslation("I18N_COMMUNITY_COMMENT_MODIFY_PLACEHOLDER")}
                      ref={this.modifyCommentRef}
                      onKeyDown={(e) => {
                        if (this.state.isMobile === true) {
                          this.commentMobileKey(e);
                        } else {
                          if (e.key === 'Enter' && !e.shiftKey) {
                            axios.put('/api/guest/ssqData/doccomment/update',
                              {
                                commentCnts: this.state.commentUpdate === '' ? ele.commentCnts : this.state.commentUpdate,
                                docCommentId: ele.docCommentId
                              }).then(res => {
                              console.log("update-comment", res.data);
                              ele.showInput = false;
                              ele.modifyReview = false;
                              if (this.state.commentUpdate === '') {
                                console.log('수정 값 없음');
                                ele.showInput = false;
                                ele.modifyReview = false;
                              } else {
                                ele.commentCnts = this.state.commentUpdate;
                              }
                              this.setState({commentList: this.state.commentList.slice()});
                            }).catch((E) => {
                              console.error("E", E);
                            });
                          }
                          if (e.key === 'Enter' && e.shiftKey) {
                            if (e.nativeEvent.isComposing === false) {
                              return;
                            }
                          }
                          //textarea 자동 줄바꿈 막음
                          if (e.key === 'Enter') {
                            e.preventDefault();
                          }
                        }
                      }}
                      onChange={(e) => {
                        this.setState({commentUpdate: e.target.value});
                        this.commentModifyAutoSize();
                      }} defaultValue={ele.commentCnts}
                    />
                    <button className="review-del"
                      onClick={() => {
                        if (confirm(this.getTranslation("I18N_COMMUNITY_COMMENT_MODIFY_CONFIRM"))) {
                          ele.showInput = false;
                          ele.modifyReview = true;
                          let commentList = this.state.commentList.slice();
                          this.setState({commentList, comment: ''});
                          console.log("수정 취소 성공");
                        } else {
                          console.log("수정유지");
                        }

                      }}
                    ></button>

                    <button className="review-enter"
                      onClick={() => {
                        axios.put('/api/guest/ssqData/doccomment/update',
                          {
                            commentCnts: this.state.commentUpdate === '' ? ele.commentCnts : this.state.commentUpdate,
                            docCommentId: ele.docCommentId
                          }).then(res => {
                          console.log("update-comment", res.data);
                          ele.showInput = false;
                          ele.modifyReview = false;
                          if (this.state.commentUpdate === '') {
                            console.log('수정 값 없음');
                            ele.showInput = false;
                            ele.modifyReview = false;
                          } else {
                            ele.commentCnts = this.state.commentUpdate;
                          }
                          this.setState({commentList: this.state.commentList.slice()});
                        }).catch((E) => {
                          console.error("E", E);
                        });
                      }}

                    ></button>
                  </div>
                  : ""
                }
              </div>

            </div>


          </div>
          <div className="mobile-black"
            style={{display: ele.modifyReview || ele.reportReview ? 'block' : ''}}></div>
        </div>)}
      </BlogPagePopupTop>

      {/*댓글 작성*/}
      <div className="review-input">
        <textarea rows={1} name="" placeholder={this.getTranslation("I18N_COMMUNITY_COMMENT_PLACEHOLDER")}
          ref={this.saveCommentRef}
          onKeyDown={(e) => this.handleInputKeyDown(e)}
          onChange={(e) => {
            this.setState({comment: e.target.value || ''});
            this.commentSaveAutoSize();
          }} value={this.state.comment}/>
        <button className={clsx("ent", this.state.isMobile ? "on" : "")}
          onClick={() => this.handleClick('save_Comment')}></button>
      </div>

      {/*댓글창 비로그인 시 로그인 팝업창 나옴*/}
      <AllPopupWrap>
        {this.state.showLoginPopup && this.renderLoginPopupOrLoginFailPopup()}
        {this.state.showSignupPopup && this.renderSignupPopup()}
        {this.state.showSignupSocialPopup && this.renderSignupSocialPopup()}
        {this.state.showTermsDetailPopup && this.renderTermsDetailPopup()}
        {this.state.showTermsDetailPrivatePopup && this.renderTermsDetailPrivatePopup()}
        {this.state.showSendVerifyEmailPopup && this.renderSendVerifyEmailPopup()}
        {this.state.showPasswordResetPopup && this.renderPasswordResetPopup()}
        {this.state.showSendPasswordResetEmailPopup && this.renderSendPasswordResetEmailPopup()}
      </AllPopupWrap>
      {(this.state.showUserPopup) && <TranPopupOverlay
        aria-label={"popup-overlay"}
      />}
      {(this.state.showLoginPopup || this.state.showSignupPopup || this.state.showSignupSocialPopup)
        && <AllPopupOverlay aria-label={"popup-overlay"}/>}
    </>;
  }

  /*댓글 입력 엔터키 동작*/
  handleInputKeyDown(e) {
    this.state.isMobile ? this.commentMobileKey(e) : this.saveCommentPcKey(e);
  }

  //모바일 엔터키
  commentMobileKey(e) {
    if (e.key === 'Enter') {
      if (e.nativeEvent.isComposing === false) {
        this.props.loginInfo.userId === undefined ?
          this.setState({
            showUserPopup: false,
            showLoginPopup: true
          })
          : null;
      }
    }
  }

  //Pc 엔터키 및 Shift+Enter
  saveCommentPcKey(e) {
    if (e.key === 'Enter' && e.shiftKey) {
      return;
    } else if (e.key === 'Enter' && !e.shiftKey) {
      if (e.nativeEvent.isComposing === false) {
        this.props.loginInfo.userId === undefined ?
          this.setState({
            showUserPopup: false,
            showLoginPopup: true
          })
          :
          // 추가.
          this.state.comment == "" ?
            alert(this.getTranslation("I18N_COMMUNITY_NO_COMMENT")) :
            this.onSave();
      }
    }
    //textarea 자동 줄바꿈 막음
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  }

  //댓글 작성 textarea 높이 자동 조절
  commentSaveAutoSize() {
    //높이 초기화
    this.saveCommentRef.current.style.height = "auto";
    if (window.innerWidth > 764) {
      this.saveCommentRef.current.style.height = (this.saveCommentRef.current.scrollHeight / 10) + "rem";
    } else {
      this.saveCommentRef.current.style.height = (this.saveCommentRef.current.scrollHeight / 10) * 1.09 + "rem";
    }
  }

  //댓글 수정 textarea 높이 자동 조절
  commentModifyAutoSize() {
    //높이 초기화
    this.modifyCommentRef.current.style.height = "2.2rem";
    if (window.innerWidth > 764) {
      this.modifyCommentRef.current.style.height = (this.modifyCommentRef.current.scrollHeight / 10) + "rem";
    } else {
      this.modifyCommentRef.current.style.height = (this.modifyCommentRef.current.scrollHeight / 10) * 1.09 + "rem";
    }
  }

  /*댓글 저장*/
  onSave() {
    // save
    let comment = new DocCommentInfo();
    comment.commentCnts = this.state.comment;
    comment.docId = this.state.selectedDocumentDetail?.id;
    comment.writerNm = this.props.loginInfo.name;
    comment.writerId = this.props.loginInfo.userId;
    comment.writerNcnm = this.props.loginInfo.nickname;
    comment.employ = this.props.loginInfo.loginType == "WELS" ? true : false;

    /*작성 댓글 리스트에 바로 출력함*/
    console.log("comment ----", comment);

    /*두번 클릭 방지*/
    this.setState({comment: ''});

    axios.post('/api/guest/ssqData/doccomment', comment).then(res => {
      console.log("save result ", res.data);

      let commentList = this.state.commentList.slice();
      commentList.push(res.data);
      /*댓글 리스트 출력 후 작성한 댓글 사라짐*/
      this.setState({commentList, comment: ''});
    }).catch((e) => {
      console.error("E", e);
    });
  }

  /*하단 연관 카테고리 부분*/
  renderBlogPageCategory() {
    const {country, lang} = langutil.splitLangCode(this.props.languageService.lang());

    return <>
      <BlogPageFooterCategory>
        <div className="view-outer">
          <div className="view-outer-left">
            <div className="conn-category">
              {this.state.productCategories.length > 0 && <SolutionRelated>
                <div
                  className={"related_tit"}>{this.getTranslation("I18N_PRODUCT_CATEGORY")}<img
                  alt={"link_icon.svg"}
                  src={SsqImages.product.linkicon()}/></div>
                <div className={"related_list one-line"}>
                  {this.state.productCategories.map((productCategory, index) => {
                    return <div key={index}>
                  <span
                    onClick={() => this.props.history.push(`/${country}/${lang}/product/category/` + productCategory.categoryId)}
                  >{productCategory.parentsCategory}</span>
                    </div>;
                  })}
                </div>
              </SolutionRelated>
              }
            </div>
          </div>

          <div className="view-outer-right">
            {this.state.industryCategories.length > 0 && <div className="conn-category">
              <SolutionRelated>
                <div
                  className={"related_tit"}>{this.getTranslation("I18N_INDUSTRY_CATEGORY")}<img
                  alt={"link_icon.svg"}
                  src={SsqImages.product.linkicon()}/></div>
                <div className={"related_list"}>
                  {this.state.industryCategories.map((industryCategory, index) => {
                    return <div key={index}>
                        <span
                          onClick={() => this.props.history.push(`/${country}/${lang}/solution/category/` + industryCategory.categoryId)}
                        >{industryCategory.categoryName}</span>
                      {(index < (this.state.industryCategories.length - 1)) &&
                        <span className={"comma"}>, </span>}
                    </div>;
                  })}
                </div>
              </SolutionRelated>
            </div>}
            {this.state.applicationLoadCategories.length > 0 && <div className="conn-category">
              <SolutionRelated>
                <div
                  className={"related_tit"}>{this.getTranslation("I18N_APPLICATION_LOAD_CATEGORY")}<img
                  alt={"link_icon.svg"}
                  src={SsqImages.product.linkicon()}/></div>
                <div className={"related_list"}>
                  {this.state.applicationLoadCategories.map((applicationLoadCategory, index) => {
                    return <div key={index}>
                      <span
                        onClick={() => this.props.history.push(`/${country}/${lang}/solution/category/` + applicationLoadCategory.categoryId)}
                      >{applicationLoadCategory.categoryName}</span>
                      {(index < (this.state.applicationLoadCategories.length - 1)) &&
                        <span className={"comma"}>, </span>}
                    </div>;
                  })}
                </div>
              </SolutionRelated>
            </div>}
          </div>
        </div>
      </BlogPageFooterCategory>
    </>;
  }

  /*문서 하단 전체 footer*/
  renderBlogPageFooter() {
    return <>
      <BlogPageFooter>

        {/*다운로드*/}
        {this.state.selectedVersionItem.files.length > 0 && this.renderBlogPageDownLoad()}

        {/*댓글 작성*/}
        {this.renderBlogPageComment()}
      </BlogPageFooter>

    </>;
  }

  handleDownloadPDF = () => {
    /* 지정된 요소 ID 값으로 가져오기 */
    const printIndexElement = document.getElementById('print-index-area');
    const printElement = document.getElementById('print-area');
    if (!printElement) return;

    /* 특정 영역만 출력하고 img 로드 체크를 위한 iframe 사용 */
    const printWindow = document.createElement('iframe');
    printWindow.style.position = 'absolute';
    printWindow.style.width = '0px';
    printWindow.style.height = '0px';
    printWindow.style.border = 'none';
    document.body.appendChild(printWindow);

    const doc = printWindow.contentDocument || printWindow.contentWindow?.document;
    if (!doc) return;

    /* window print 시 상단에 로고 추가 */
    const logoHTML = `
      <div class="print-logo-area">
        <img alt="ssq_logo.svg" src="${SsqImages.common.logo.lsHeader()}" style="max-width: 150px; height: auto;"/>
        <span class="solution-square">Solution Square</span>
        <hr/>
      </div>
    `;

    const indexHTML = printIndexElement ? Array.from(printIndexElement.children).map((item) => {
      const button = item.querySelector('button');
      if (!button) return '';
      const text = button.textContent;
      const id = item.id.substring(4);

      return `<li><a href="#${id}">${text}</a></li>`
    }).join("") : "";

    const indexContainerHTML = indexHTML
      ? `<div class="index-container"><h3>목차</h3><ul>${indexHTML}</ul></div>`
      : "";

    const contentHTML = printElement.innerHTML.replace(
      /(<div[^>]*>\s*<div class="SsqEditor ck-content"[^>]*>)/, `${indexContainerHTML}$1`
    )

    console.log("indexHTML", indexHTML);
    console.log("contentHTML", contentHTML);
    /* CSS 적용 */
    const getStyles = () => {
      const stylesArray = Array.from(document.styleSheets)
        .map((sheet) => {
          try {
            return Array.from(sheet.cssRules).map(rule => rule.cssText).join("\n");
          } catch (e) {
            return '';
          }
        });

      const mediaPrintStyle = `

        @media print {
          .index-container {
            display: inline-block;
            width: fit-content;
            margin-bottom: 3rem;
            padding: 1rem;
            border: 1px solid #d8d8d8;
          }
          .index-container > h3 {
            padding-bottom: 1rem;
            text-align: left;
          }
          a[href^="#h1"], a[href^="#h2"], a[href^="#h3"] {
            word-wrap: break-word;
            width: 100%;
            text-align: center;
            ${fontFamilyMedium};
          }
          a[href^="#h1"] {
            font-size: 1rem;
            color: #0275D8; !important;
            line-height: 2rem;
            position: relative;
          }
          a[href^="#h2"] {
            font-size: 1rem;
            color: #0275D8 !important;
            line-height: 2rem;
            padding-left: 1.6rem;
            position: relative;
          }
          a[href^="#h3"] {
            font-size: 1rem;
            color: #0275D8 !important;
            line-height: 2rem;
            padding-left: 3.2rem;
            position: relative;
          }
          .comment-box.solution-profile {
            display: flex;
          }
          .view-content-tag {
            color: #7783A1;
            margin: 1.2rem auto;
          }
          .view-content-tag ul {
            display: flex;
            flex-wrap: wrap;
            gap: 1.5rem;
          }
          .view-content-tag li {
            display: inline-block;
            white-space: nowrap;
          }
          .print-logo-area {
            display: flex;
            width: 100%;
            height: 7rem;
            border-bottom: 1px solid #d8d8d8;
            margin-bottom: 2rem;
            justify-content: center;
            align-items: center;
            img {
              position: relative;
            }
            span {
              ${fontFamilyMedium};
              font-size: 1.2rem;
              color: #90A0B6;
              margin-left: .6rem;
              position: relative;
              top: .6rem;
            }
          }
          .c-view {
            color: #407EDB;
            background: url(${img_icon_c_view}) no-repeat left center;
            padding-left: 1.8rem;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
          .c-comment {
            background: url(${img_icon_c_comment}) no-repeat left center;
            padding-left: 1.8rem;
            color: #407EDB;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
          .c-time {
            background: url(${img_icon_c_time}) no-repeat left center;
            padding-left: 1.8rem;
            margin-left: .8rem;
            background-size: 1.6rem;
            ${fontFamilyRegular};
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
          .c-txt.employee {
            color: #7783A1;
            background: #F1F3F6;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
          .c-txt.count {
            &.first {
              color: #EDAE0A;
              background: rgba(247, 185, 27, 0.10);
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
            &.second {
              color: #FF7A00;
              background: #FFE4CC;
            }
            &.third {
              color: #7B5DF1;
              background: #E5DFFC;
            }
            &.fourth {
              color: #407EDB;
              background: #D9E5F8;
            }
            &.fifth {
              color: #7C899E;
              background: #E5E7EC;
            }
          }
          .break-page {
            page-break-before: always;
          }
        }
      `;
      return stylesArray.join("\n") + "\n" + mediaPrintStyle
    };
    const styles = getStyles();

    doc.open();
    doc.write(`
      <html>
        <head>
          <style>
            ${styles}
          </style>
        </head>
        <body>
          ${logoHTML}
          ${contentHTML}
        </body>
      </html>
    `);
    doc.close();

    /* img 로딩 체크 */
    const images = Array.from(doc.getElementsByTagName('img'));
    let loadedCount = 0;
    const totalImages = images.length;

    if (totalImages === 0) {
      printWindow.contentWindow?.focus();
      printWindow.contentWindow?.print();
      setTimeout(() => document.body.removeChild(printWindow), 1000);
    } else {
      for (let img of images) {
        img.onload = img.onerror = () => {
          loadedCount++;
          if (loadedCount === totalImages) {
            setTimeout(() => {
              printWindow.contentWindow?.focus();
              printWindow.contentWindow?.print();
              setTimeout(() => document.body.removeChild(printWindow), 1000);
            }, 300);
          }
        };
      }

      /* 최대 대기 시간 3초) */
      setTimeout(() => {
        if (loadedCount < totalImages) {
          console.log("일부 이미지 로드 실패");
          printWindow.contentWindow?.focus();
          printWindow.contentWindow?.print();
          setTimeout(() => document.body.removeChild(printWindow), 1000);
        }
      }, 3000);
    }
  };

  /*글쓰기 수정/삭제*/
  modifyPostOn() {
    console.log("-- modifyPostOn", this.state.modifyPost);
    this.setState({modifyPost: !this.state.modifyPost});
    //this.setState({modifyPostClick: this.state.modifyPost});
  }

  /* 추천, 비추천 생성 */
  async createDocGoodBad(data: IDocGoodBadInfo) {
    const response = await axios.post('/api/guest/ssqData/docgoodbad/create', data);
    console.log("추천 생성 완료", response, data.goodBad);
    this.setState({docGoodCnt: response.data.goodCount, docBadCnt: response.data.badCount});
  }

  /* 추천, 비추천 삭제 */
  async deleteDocGoodBad(data: IDocGoodBadInfo) {
    const response = await axios.post('/api/guest/ssqData/docgoodbad/delete', data);
    console.log("추천 삭제 완료", response, data.goodBad);
    this.setState({docGoodCnt: response.data.goodCount, docBadCnt: response.data.badCount});
  }

  requestDocGoodBad(type: string) {
    if (!this.props.loginInfo?.userId)
      return this.setState({showLoginPopup: true, showUserPopup: false});

    const data: IDocGoodBadInfo = {
      docId: this.state.selectedDocumentDetail.id,
      userId: this.props.loginInfo?.userId,
      docType: this.state.selectedDocumentDetail.docType,
      docTitle: this.state.selectedDocumentDetail.docTitle,
      goodBad: type,
      updtDt: new Date(0)
    };

    switch (type) {
      case "GOOD":
        if (!this.state.docGood) {
          this.createDocGoodBad(data);
          this.setState({docGood: true, docBad: false});
        } else {
          this.deleteDocGoodBad(data);
          this.setState({docGood: false, docBad: false});
        }
        break;
      case "BAD":
        if (!this.state.docBad) {
          this.createDocGoodBad(data);
          this.setState({docGood: false, docBad: true});
        } else {
          this.deleteDocGoodBad(data);
          this.setState({docGood: false, docBad: false});
        }
        break;
    }
  }

  /* 추천, 비추천 체크 표시 여부 호출 */
  async getMyCheckDocGoodBad(data: IMyCheckDocGoodBad) {
    await axios.post('/api/guest/ssqData/docgoodbad/mycheck', data).then(response => {
      this.setState({
        docGood: response.data?.goodBad === "GOOD" ? true : false,
        docBad: response.data?.goodBad === "BAD" ? true : false
      });
    });
  }

  /* 추천, 비추천 Count 정보 호출 */
  async getCountDocGoodBad(docId: number) {
    await axios.get(`/api/guest/ssqData/docgoodbad/count/${docId}`).then(response => {
      this.setState({docGoodCnt: response.data.goodCount, docBadCnt: response.data.badCount});
    });
  }

  handleClick(cmd: string, data?) {
    const {country, lang} = langutil.splitLangCode(this.props.languageService.lang());
    //if( e && e.preventDefault) e.preventDefault();
    console.log("cmd ", cmd, " data ", data);
    switch (cmd) {
      case 'modifyPost' :
        this.state.selectedDocumentDetail.docType == "RND_NOTI"
          ? window.open(`/${country}/${lang}/community/new/${this.state.selectedDocumentDetail.id}?docgrp=rndnoti`)
          : window.open(`/${country}/${lang}/community/new/${this.state.selectedDocumentDetail.id}?docgrp=blog`);
        return console.log('modifyPost: ', this.state.selectedDocumentDetail.id);

      case 'reportPost':
        this.props.loginInfo.userId === undefined ?
          this.setState({
            showUserPopup: false,
            showLoginPopup: true
          })
          :
          this.popReport.current.show({docId: this.state.selectedDocumentDetail.id, reportType: 'DOC'})
            .then(res => {
              console.log("res", res);
            }).catch(e => {
            console.error("E", e);
          });
        return console.log("==reportPostClick", this.state.selectedDocumentDetail.id);

      case 'reportReview':
        const d: IfDocCommentInfo = data;
        this.props.loginInfo.userId === undefined ?
          this.setState({
            showUserPopup: false,
            showLoginPopup: true
          })
          :
          this.popReport.current.show({docId: d.docId, docCommentId: d.docCommentId, reportType: 'COMMENT'})
            .then(res => {
              console.log("res", res);
            })
            .catch(e => {
              console.error("E", e);
            });
        return console.log("-- reportReviewClick", this.state.reportReview);

      case 'bookMark' :
        /* 북마크 선택, 취소 (toggle 기능) */
        if (!this.props.loginInfo?.userId)
          return this.setState({showLoginPopup: true, showUserPopup: false});
        else {
          axios.post(`/api/guest/ssqData/bookmark/toggle`, {
            userId: this.props.loginInfo?.userId,
            docId: this.props.match.params.documentId,
            isBookmark: !this.state.bookMarkClick
          }).then(response => {
            console.log("bookmark toggle", response);
            this.props.openToast(this.state.bookMarkClick ? 'bookmark' : 'bookmark-clear');
            this.setState({seq: this.state.seq + 1, toastType: this.state.bookMarkClick ? 'bookmark' : 'bookmark-clear'});
            this.setState({bookMarkClick: !this.state.bookMarkClick});
            console.log("--bookMark", this.state.bookMarkClick);
          });
        }
        break;

      case 'clickFeedbackButton' :
        let pageFeedback: ICreatePostFeedback = {
          feedbackType: this.state.feedbackGood ? FeedbackType.GOOD : FeedbackType.BAD,
          comment: this.state.feedbackComment,
          feedbackWriterId: "",
          feedbackWriterNickname: "",
          documentId: this.state.selectedDocumentDetail.id,
        };

        this.props.ssqDataRepository.postFeedback(pageFeedback)
          .then((res) => {
            console.log('피드백 저장 완료', res);
            alert(this.getTranslation("I18N_COMMUNITY_FEEDBACK_ALERT"));

            this.setState({
              feedbackBad: false,
              feedbackGood: true,
              feedbackComment: "",
            });
          }).catch((err) => {
          console.log('피드백 저장 실패', err);
        });
        return console.log('CLICK FEEDBACK BUTTON');

      case "save_Comment":
        this.props.loginInfo.userId === undefined ?
          this.setState({
            showUserPopup: false,
            showLoginPopup: true
          })
          :
          this.state.comment == "" ?
            alert(this.getTranslation("I18N_COMMUNITY_NO_COMMENT")) :
            this.onSave();
        return console.log("댓글 저장 || 로그인 필요");


      case "deleteReview":
        console.log("댓글 삭제 start");
        axios.delete(`/api/guest/ssqData/doccomment/${data}`).then(res => {
          console.log("댓글 삭제 delete ok ", res.data);
          this.setState({commentList: this.state.commentList.filter((ele) => ele.docCommentId !== data)});
        }).catch(e => {
          console.error("댓글 삭제 delete error ", e);
        });
        break;

      case 'deletePost' :
        if (docutil.approvalRequried(this.state.selectedDocumentDetail.docType)) {
          this.refPopDelReq.current.show({doc: this.state.selectedDocumentDetail}).then(res => {
            ["RND_NOTI"].includes(this.state.selectedDocumentDetail.docType) ? window.open(`/${country}/${lang}/community/rnd?tab=noti`, '_self')
              : window.open(`/${country}/${lang}/community/blog`, '_self');
          }).catch(e => {
            console.error("E", e);
          });
        } else if (confirm(this.getTranslation("I18N_COMMUNITY_CONFIRM_DELETE"))) {
          this.props.ssqDataRepository.deleteCommunityDocument(this.state.selectedDocumentDetail.id).then(r => {
            if (r === 200) {
              alert(this.getTranslation("I18N_COMMUNITY_CONFIRM_DELETE_SUCCESS"));
              ["RND_NOTI"].includes(this.state.selectedDocumentDetail.docType) ? window.open(`/${country}/${lang}/community/rnd?tab=noti`, '_self')
                : ["PARTNER_NOTI"].includes(this.state.selectedDocumentDetail.docType)
                  ? window.open(`/${country}/${lang}/community/partner?tab=noti`, '_self')
                  : window.open(`/${country}/${lang}/community/blog`, '_self');
            } else {
              alert(this.getTranslation("I18N_COMMUNITY_ERROR_DELETE"));
            }
          });
        }
        break;
    }
  }

  checkAdminRnd() {
    if (this.props.loginInfo.allowAdminKoKr && roleutil.hasRole("RND", this.props.loginInfo.userRoles)
      && this.state.selectedDocumentDetail.exposeSiteLanguage == "ko-KR" && this.props.loginInfo.allowAdminManage) {
      return this.setState({rndKr: true});
    } else if (this.props.loginInfo.allowAdminEn && roleutil.hasRole("RND", this.props.loginInfo.userRoles)
      && this.state.selectedDocumentDetail.exposeSiteLanguage == "en" && this.props.loginInfo.allowAdminManage) {
      return this.setState({rndEn: true});
    } else if (this.props.loginInfo.allowAdminEnUs && roleutil.hasRole("RND", this.props.loginInfo.userRoles)
      && this.state.selectedDocumentDetail.exposeSiteLanguage == "en-US" && this.props.loginInfo.allowAdminManage) {
      return this.setState({rndEnUs: true});
    }
    return false;
  }

  renderBlogPageDetail() {
    const t = i18ntrans.common;
    return <>
      {/*//상단 : 사용자 정보*/}
      <HelmetTitleAndH1
        title={['RND_NOTI'].includes(this.state.selectedDocumentDetail.docType)
          ? tcommona('I18N_COMMON_TIT_RND', [this.state.selectedDocumentDetail?.docTitle, '-'], [getLangSuffix()])
          : tcommona('I18N_COMMON_TIT_TECHLOG', [this.state.selectedDocumentDetail?.docTitle, ' - '], [getLangSuffix()])}/>
      <BlogPagePopupMain>
        <section className="community-view">
          <div className="wrapper container view-container">
            <div className="community__content">
              <div>
                <div className="content">
                  <BlogPagePopupTop>
                    <div className="view-header">
                      <div className="view-header-item">
                        <div className="v-header-left">
                          <div
                            className={"blog-type-info"}>{this.state.isMounted == false ? "'" :
                            ["RND_NOTI", "PARTNER_NOTI"].includes(this.state.selectedDocumentDetail.docType) ?
                              this.getTranslation('I18N_COMMUNITY_RND_NOTICE') :
                              this.getTranslation(`I18N_COMMUNITY_BLOG_SELECT_${this.state.selectedDocumentDetail.docType}`)}</div>
                          <CommentWrap className="view-comment-wrap">
                            <SimpleUserProfile
                              userId={this.state.selectedDocumentDetail.writerId}
                              displayLoginPopup={this.props.displayLoginPopup}/>
                            <CommunityPostInfo type={"view"}
                              commentList={this.state.commentList}
                              ssqDocument={this.state.selectedDocumentDetail}
                              time={this.state.selectedDocumentDetail.updateTime}
                              count={this.state.selectedDocumentDetail.clickCount}></CommunityPostInfo>
                          </CommentWrap>
                        </div>
                        <div className="v-header-right">
                          <ul className="comment-box">
                            <li>
                              <button onClick={this.handleDownloadPDF} className="pdf-download-button">
                                <img src={SsqImages.common.icon.downPdf()} alt="PDF" />
                              </button>
                            </li>


                            <li>
                              <button
                                className={clsx("view-like", this.props.loginInfo?.userId && this.state.docGood ? 'on' : '')}
                                onMouseEnter={(e) => {
                                  e.stopPropagation();
                                  this.setState({goodHover: true});
                                }}
                                onMouseLeave={(e) => {
                                  e.stopPropagation();
                                  this.setState({goodHover: false});
                                }}
                                onClick={(e) => this.requestDocGoodBad("GOOD")}>
                                {this.state.docGoodCnt}</button>
                              {this.state.goodHover &&
                                <CommunityPostHoverText type={'good'}/>}
                            </li>


                            <li>
                              <button
                                className={clsx("view-bad", this.props.loginInfo?.userId && this.state.docBad ? 'on' : '')}
                                onMouseEnter={(e) => {
                                  e.stopPropagation();
                                  this.setState({badHover: true});
                                }}
                                onMouseLeave={(e) => {
                                  e.stopPropagation();
                                  this.setState({badHover: false});
                                }}
                                onClick={(e) => this.requestDocGoodBad("BAD")}>
                                {this.state.docBadCnt}</button>
                              {this.state.badHover &&
                                <CommunityPostHoverText type={'bad'}/>}
                            </li>


                            <li>
                              <button
                                className={clsx("view-bookmark", this.props.loginInfo?.userId && this.state.bookMarkClick ? 'on' : '')}
                                onMouseEnter={(e) => {
                                  e.stopPropagation();
                                  this.setState({bookMarkHover: true});
                                }}
                                onMouseLeave={(e) => {
                                  e.stopPropagation();
                                  this.setState({bookMarkHover: false});
                                }}
                                onClick={(e) => this.handleClick('bookMark')}>
                              </button>
                              {this.state.bookMarkHover &&
                                <CommunityPostHoverText type={'bookMark'}/>}
                            </li>


                            <li className="view-share"
                              onMouseEnter={(e) => {
                                e.stopPropagation();
                                this.setState({shareHover: true});
                              }}
                              onMouseLeave={(e) => {
                                e.stopPropagation();
                                this.setState({shareHover: false});
                              }}
                              onClick={async () => {
                                this.copyToClipboardCurrentUrl();
                                await this.postUserShare(this.state.selectedDocumentDetail);
                                this.props.openToast('share');
                                this.setState({seq: this.state.seq + 1, toastType: 'share'});
                              }}>
                              {this.state.shareHover &&
                                <CommunityPostHoverText type={'share'}/>}
                            </li>

                          </ul>

                          <button className={clsx("btn-list-modify")}
                            ref={this.outSideClickPost}
                            onMouseEnter={(e) => {
                              e.stopPropagation();
                              this.setState({moreHover: true});
                            }}
                            onMouseLeave={(e) => {
                              e.stopPropagation();
                              this.setState({moreHover: false});
                            }}
                            onClick={() => this.modifyPostOn()}>
                            {this.state.moreHover &&
                              <CommunityPostHoverText type={'more'}/>}
                          </button>

                        </div>

                      </div>

                      {this.props.loginInfo.userId === this.state.selectedDocumentDetail.writerId ?
                        <div className={clsx("modify-item-body")}
                          style={{display: this.state.modifyPost ? 'block' : ''}}>
                          <button className={clsx("modify-btn modify")}
                            onClick={() => this.handleClick('modifyPost', 'modifyPost')}
                          >{this.getTranslation('I18N_COMMUNITY_MODIFY')}
                          </button>
                          <button className="modify-btn modify"
                            onClick={() => this.handleClick('deletePost', 'deletePost')}
                          > {this.getTranslation('I18N_COMMUNITY_DELETE')}
                          </button>
                        </div>
                        :
                        (this.state.selectedDocumentDetail.docType.includes(DocType.TECHNICAL_GUIDE) ||
                          this.state.selectedDocumentDetail.docType.includes(DocType.APPLICATION_NOTE)) && loginutil.islse(this.props.loginInfo) ?
                          <div className={clsx("modify-item-body")}
                            style={{display: this.state.modifyPost ? 'block' : ''}}>
                            <button className={clsx("modify-btn modify")}
                              onClick={() => {
                                this.handleClick('reportPost', this.state.selectedDocumentDetail.id);
                                this.setState({modifyPost: false});
                              }}

                            >{this.getTranslation('I18N_COMMUNITY_COMMENT_REPORT')}
                            </button>
                            <button className={clsx("modify-btn modify")}
                              onClick={() => this.handleClick('modifyPost', 'modifyPost')}

                            >{this.getTranslation('I18N_COMMUNITY_MODIFY')}
                            </button>
                          </div>
                          :
                          //관리자권한 문서 수정 권한 -- RND 공지사항, 일반 포스트, 파트너 공지사항 --> 신고/수정
                          (this.state.selectedDocumentDetail.docType === (DocType.TECH_GENERAL)
                            && (this.props.loginInfo.allowAdminKoKr || this.props.loginInfo.allowAdminEn || this.props.loginInfo.allowAdminEnUs === true)) ||
                          ((this.state.rndKr || this.state.rndEn || this.state.rndEnUs == true) && (this.state.selectedDocumentDetail.docType === (DocType.RND_NOTI))) ||
                          ((DocType.PARTNER_QNA_Q) && this.props.loginInfo.allowAdminManage)
                            ?
                            <div className={clsx("modify-item-body")}
                              style={{display: this.state.modifyPost ? 'block' : ''}}>
                              <button className={clsx("modify-btn modify")}
                                onClick={() => {
                                  this.handleClick('reportPost', this.state.selectedDocumentDetail.id);
                                  this.setState({modifyPost: false});
                                }}

                              >{this.getTranslation('I18N_COMMUNITY_COMMENT_REPORT')}
                              </button>
                              <button className={clsx("modify-btn modify")}
                                onClick={() => this.handleClick('modifyPost', 'modifyPost')}

                              >{this.getTranslation('I18N_COMMUNITY_MODIFY')}
                              </button>
                            </div>
                            :
                            <div className={clsx("modify-item-body")}
                              style={{display: this.state.modifyPost ? 'block' : ''}}>
                              <button className={clsx("modify-btn notify modify")}
                                onClick={() => {
                                  this.handleClick('reportPost', this.state.selectedDocumentDetail.id);
                                  this.setState({modifyPost: false});
                                }}

                              >{this.getTranslation('I18N_COMMUNITY_COMMENT_REPORT')}
                              </button>
                            </div>
                      }
                    </div>
                  </BlogPagePopupTop>


                  {/*상단 제목 태그들*/}
                  <BlogPagePopupTitleTag>
                    <div className="view-content" id="print-area">
                      <div className="view-content-tag">
                        <ul>
                          <li
                            className="blog-type">{this.state.isMounted == false ? "'" :
                            ["RND_NOTI", "PARTNER_NOTI"].includes(this.state.selectedDocumentDetail.docType)
                              ? this.getTranslation("I18N_COMMUNITY_RND_NOTICE")
                              : tcommona('I18N_COMMON_TIT_TECHLOG', [getLangSuffix()]).split('-')[0] + " > " + this.getTranslation(`I18N_COMMUNITY_BLOG_SELECT_${this.state.selectedDocumentDetail.docType}`)}</li>
                          {this.state.tags.map((tag, index) => (
                            <li key={index}>#{tag.tag}</li>
                          ))}
                        </ul>
                      </div>

                      {/* 제목*/}
                      <SolutionTop>
                        <div className={"solution-tit"}>
                          {this.state.selectedDocumentDetail.docTitle}
                          {this.state.selectedDocumentDetail.displayTarget == 15 &&
                            <span className={"partner-level"}>{t("I18N_COMMON_PARTNER_ONLY")}</span>}
                          {this.state.selectedDocumentDetail.displayTarget == 20 && ![DocType.RND_NOTI].includes(this.state.selectedDocumentDetail.docType) &&
                            <p className={"level"}>{this.getTranslation("I18N_SOLUTION_EMPLOYEE_ONLY")}</p>
                          }
                        </div>
                        <ul className="comment-box solution-profile">
                          <SimpleUserProfile
                            userId={this.state.selectedDocumentDetail.writerId}
                            displayLoginPopup={this.props.displayLoginPopup}/>
                          <CommunityPostInfo type={"view"}
                            commentList={this.state.commentList}
                            ssqDocument={this.state.selectedDocumentDetail}
                            time={this.state.selectedDocumentDetail.updateTime}
                            count={this.state.selectedDocumentDetail.clickCount}></CommunityPostInfo>
                        </ul>
                      </SolutionTop>

                      {/* 내용*/}
                      <SolutionResult>
                        <div
                          className={"SsqEditor ck-content"}>{this.state.descriptionParsedResult}</div>
                      </SolutionResult>
                    </div>

                    {/*하단 다운로드, 댓글 출력*/}

                    {this.renderBlogPageFooter()}
                  </BlogPagePopupTitleTag>

                </div>
                {/*하단 연관 카테고리 출력*/}
                <div className="commu_bottom_cont">
                  {this.state.productCategories.length > 0 ? this.renderBlogPageCategory() : null}
                  {/*사이드 하단 피드백 부분*/}
                </div>
              </div>
              {/*{this.renderBlogPageCategory()}*/}

              {/*오른쪽 사이드 출력*/}
              {this.renderBlogPageAside()}

            </div>

          </div>
          <div className="mobile-black"
            style={{display: this.state.modifyPost || this.state.modifyReview ? 'block' : 'none'}}></div>

        </section>
        <PopReport ref={this.popReport} trans={this.getReportTrans}
          ssqDataRepository={this.props.ssqDataRepository}
          languageService={this.props.languageService}/>
      </BlogPagePopupMain>
    </>;
  }

  renderNotFoundPage() {
    return <NotFoundPage languageService={this.props.languageService}/>;
  }

  render() {
    return <div>
      <ReqDelPopupWrap ref={this.refPopDelReq}/>
      {this.state.isMounted && this.state.selectedDocumentDetail === emptySsqDataDocument ?
        this.renderNotFoundPage() : this.renderBlogPageDetail()
      }
    </div>;
  }

  showLoginPopupFunc = (showLoginPopup: boolean) => {
    this.setState({showLoginPopup: showLoginPopup});
  };

  setIsLoggedInFunc = (isLoggedIn: boolean) => {
    this.setState({isLoggedIn: isLoggedIn});
  };

  setLoginInputValuesFunc = (loginInputValues: LoginInputValues) => {
    this.setState({loginInputValues: loginInputValues});
  };

  /*로그인 실패*/
  showLoginFailPopupFunc = (showLoginFailPopup: boolean, loginInputValues?: LoginInputValues) => {
    this.setState({
      showLoginFailPopup: showLoginFailPopup,
      showLoginPopup: true
    });

    if (loginInputValues) {
      this.setState({
        loginInputValues
      });
    }
  };

  /*회원가입*/
  showSignupPopupFunc = (showSignupPopup: boolean) => {
    this.setState({showSignupPopup: showSignupPopup});
  };

  closeSocialSignupPopupFunc = () => {
    this.setState({
      showSignupSocialPopup: false,
      showLoginPopup: true
    });
  };

  showSendVerifyEmailPopupFunc = (showSendVerifyEmailPopup: boolean) => {
    this.setState({showSendVerifyEmailPopup: showSendVerifyEmailPopup});
  };


  setSignupEmailFunc = (signupEmail: string) => {
    this.setState({signupEmail: signupEmail});
  };

  showSignupSocialPopupFunc = (
    showSignupSocialPopup: boolean,
    socialSignupInfo: SocialSignupInfo) => {

    this.setState({
      showSignupSocialPopup: showSignupSocialPopup,
      socialSignupInfo: socialSignupInfo
    });
  };

  showPasswordResetPopupFunc = (showPasswordResetPopup: boolean) => {
    this.setState({showPasswordResetPopup: showPasswordResetPopup});
  };

  closeAllPopupFunc = (showUserPopup: boolean,
    showLoginPopup: boolean,
    showSignupPopup: boolean,
    showSendVerifyEmailPopup: boolean,
    showPasswordResetPopup: boolean,
    showSendPasswordResetEmailPopup: boolean) => {
    this.setState({
      showUserPopup: showUserPopup,
      showLoginPopup: showLoginPopup,
      showSignupPopup: showSignupPopup,
      showSendVerifyEmailPopup: showSendVerifyEmailPopup,
      showPasswordResetPopup: showPasswordResetPopup,
      showSendPasswordResetEmailPopup: showSendPasswordResetEmailPopup,
      loginInputValues: {
        id: "",
        password: ""
      }
    });
  };

  showTermsDetailPopupFunc = (showTermsDetailPopup: boolean) => {
    this.setState({showTermsDetailPopup: showTermsDetailPopup});
  };

  showTermsDetailPrivatePopupFunc = (showTermsDetailPrivatePopup: boolean, termsType: string) => {
    this.setState({
      showTermsDetailPrivatePopup,
      termsType
    });
  };
  showSendPasswordResetEmailPopupFunc = (showSendPasswordResetEmailPopup: boolean) => {
    this.setState({showSendPasswordResetEmailPopup: showSendPasswordResetEmailPopup});
  };

  setResetPasswordEmailFunc = (resetPasswordEmail: string) => {
    this.setState({resetPasswordEmail: resetPasswordEmail});
  };

  /*댓글 로그인 창 */
  private renderLoginPopupOrLoginFailPopup() {
    return <>
      {this.state.showLoginFailPopup && <LoginFailPopup
          languageService={this.props.languageService}
          accountService={this.props.accountService}
          showLoginFailPopupFunc={this.showLoginFailPopupFunc}
          loginFailedAccountId={this.state.loginInputValues.id}
        />
        ||
        <LoginPopup
          languageService={this.props.languageService}
          loginService={this.props.loginService}
          accountService={this.props.accountService}
          loginInputValues={this.state.loginInputValues}
          showLoginPopupFunc={this.showLoginPopupFunc}
          showLoginFailPopupFunc={this.showLoginFailPopupFunc}
          setIsLoggedInFunc={this.setIsLoggedInFunc}
          setLoginInputValuesFunc={this.setLoginInputValuesFunc}
          showSignupPopupFunc={this.showSignupPopupFunc}
          showSendVerifyEmailPopupFunc={this.showSendVerifyEmailPopupFunc}
          setSignupEmailFunc={this.setSignupEmailFunc}
          showSignupSocialPopupFunc={this.showSignupSocialPopupFunc}
          showPasswordResetPopupFunc={this.showPasswordResetPopupFunc}
        />}
    </>;
  }


  private renderSignupPopup() {
    return <SignupPopup
      languageService={this.props.languageService}
      accountService={this.props.accountService}
      notificationService={this.props.notificationService}
      showSignupPopupFunc={this.showSignupPopupFunc}
      closeAllPopupFunc={this.closeAllPopupFunc}
      showTermsDetailPopupFunc={this.showTermsDetailPopupFunc}
      showTermsDetailPrivatePopupFunc={this.showTermsDetailPrivatePopupFunc}
      setSignupEmailFunc={this.setSignupEmailFunc}
      showSendVerifyEmailPopupFunc={this.showSendVerifyEmailPopupFunc}
    />;
  }


  private renderSignupSocialPopup() {
    return <SignupSocialPopup
      languageService={this.props.languageService}
      accountService={this.props.accountService}
      notificationService={this.props.notificationService}
      showTermsDetailPopupFunc={this.showTermsDetailPopupFunc}
      showTermsDetailPrivatePopupFunc={this.showTermsDetailPrivatePopupFunc}
      showSignupSocialPopupFunc={this.showSignupSocialPopupFunc}
      showLoginPopupFunc={this.showLoginPopupFunc}
      socialSignupInfo={this.state.socialSignupInfo}
      closeSocialSignupPopupFunc={this.closeSocialSignupPopupFunc}
    />;
  }

  private renderTermsDetailPopup() {
    return <TermsDetailPopup
      languageService={this.props.languageService}
      showTermsDetailPopupFunc={this.showTermsDetailPopupFunc}
    />;
  }

  private renderTermsDetailPrivatePopup() {
    return <TermsDetailPrivatePopup
      languageService={this.props.languageService}
      showTermsDetailPrivateEssentialPopupFunc={this.showTermsDetailPrivatePopupFunc}
      termsType={this.state.termsType}
    />;
  }

  private renderSendVerifyEmailPopup() {
    return <SendVerifyEmailPopup
      languageService={this.props.languageService}
      notificationService={this.props.notificationService}
      signupEmail={this.state.signupEmail}
      showSendVerifyEmailPopupFunc={this.showSendVerifyEmailPopupFunc}
      showSignupPopupFunc={this.showSignupPopupFunc}
      closeAllPopupFunc={this.closeAllPopupFunc}
    />;
  }

  private renderPasswordResetPopup() {
    return <PasswordResetPopup languageService={this.props.languageService}
      accountService={this.props.accountService}
      notificationService={this.props.notificationService}
      signupEmail={this.state.signupEmail}
      showPasswordResetPopupFunc={this.showPasswordResetPopupFunc}
      showSendPasswordResetEmailPopupFunc={this.showSendPasswordResetEmailPopupFunc}
      showSignupPopupFunc={this.showSignupPopupFunc}
      closeAllPopupFunc={this.closeAllPopupFunc}
      setResetPasswordEmailFunc={this.setResetPasswordEmailFunc}
    />;
  }

  private renderSendPasswordResetEmailPopup() {
    return <SendPasswordResetEmailPopup languageService={this.props.languageService}
      accountService={this.props.accountService}
      notificationService={this.props.notificationService}
      resetPasswordEmail={this.state.resetPasswordEmail}
      showSendPasswordResetEmailPopupFunc={this.showSendPasswordResetEmailPopupFunc}
      showLoginPopupFunc={this.showLoginPopupFunc}
      closeAllPopupFunc={this.closeAllPopupFunc}
    />;
  }


  private async postUserShare(document: ISsqDataDocument) {
    const createUserShareRequest: ICreateUserShareRequest = {
      documentId: document.id,
      userId: "set userId in BFF",
      docType: document.docType,
      docTitle: document.docTitle,
      updateTime: new Date()
    };

    await this.props.ssqDataRepository.postUserShare(createUserShareRequest);
  }

  private onClickContentsItem(element: any, index: number) {
    let targetElement = document.querySelector(`#${element.type}-${index}`);
    window.scrollTo({top: 0});
    window.scrollTo({top: (targetElement?.getBoundingClientRect().y || 0) - 70});
    // 클릭 시 오른쪽 상단 class click 추가-- 송지하
    this.state.ssqEditorList.forEach((cid) => document.querySelector(`#sol-` + cid)?.classList.remove("click"));
    document.querySelector(`#sol-${element.type}-${index}`)?.classList.add("click");
    // !-- 클릭 시 오른쪽 상단 class click 추가 -- 송지하
  }
}

//export default withRouter(BlogPagePopup);


export default withRouter(connect(
  (state: any) => ({
    loginInfo: state.main.loginInfo,
    svrConf: state.main.svrConf,
  }),
)(BlogPagePopup));

const SolutionTop = styled.div`
  margin-bottom: 3rem;
  //padding: 4rem 4rem 0;

  .solution-tit-wrap {
    display: flex;
    justify-content: space-between;
  }

  .solution-info {
    display: flex;
    font-size: 1.2rem;
    color: #7783A1;
    margin-top: .8rem;
    ${fontFamilyRegular};


    span + span:before {
      content: '';
      display: inline-block;
      width: 1px;
      height: 15px;
      background: #C7D6EA;
      vertical-align: middle;
      margin: 0 4px;
    }

    span b {
      color: #407EDB;
      font-weight: inherit !important;
      margin-left: .4rem;
    }
  }

  .solution-tit {
    font-size: 2.5rem;
    ${fontFamilyBold};
    width: 95%;
    line-height: 1.5;

    .level {
      display: inline-block;
      background: #7783A1;
      color: #fff;
      border-radius: 16px;
      //width: 4.8rem;
      padding: 0 0.8rem;
      height: 1.8rem;
      line-height: 1.8rem;
      font-size: 9px;
      //font-weight: bold;
      text-align: center;
      vertical-align: middle;
      margin-left: .6rem;
    }

    .partner-level {
      display: inline-block;
      background: #F4B209;
      color: rgb(255, 255, 255);
      border-radius: 16px;
      //width: 4.8rem;
      padding: 0 0.8rem;
      height: 1.8rem;
      line-height: 1.8rem;
      font-size: 9px;
      //font-weight: bold;
      text-align: center;
      vertical-align: middle;
      margin-left: .6rem;
    }
  }

  button + button {
    margin-left: .8rem
  }

  .solution-btn button {
    height: 3rem;

    img {
      vertical-align: middle
    }

    :hover {
      background: rgba(64, 125, 217, 0.1);
    }

    :active {
      background: rgba(64, 126, 219, 0.3);
    }
  }

  @media screen and (max-width: 764px) {
    position: relative;
    padding: .2rem 1.6rem 0 1.6rem !important;

    .solution-tit {
      width: 100%
    }

    .solution-btn {
      position: absolute;
      right: 16px;
      bottom: -5px;
    }
  }
`;
const SolutionResult = styled.div`
  ${EditorStyle};

  .SsqEditor {
    padding-bottom: 4rem;
    overflow-x: auto;
  }

  .SsqEditor p,
  .SsqEditor div,
  .SsqEditor span,
  .SsqEditor li {
    word-break: keep-all;      /* 한글, 영어 단어 모두 중간에서 잘리지 않음 */
    overflow-wrap: break-word; /* 컨테이너보다 긴 단어는 줄바꿈 허용 */
    white-space: normal;       /* 일반적인 텍스트 줄바꿈 적용 */
  }

  .download {
    border-top: 1px dashed #90A0B6;

    > div:last-child {
      padding: 0 4rem 4rem;
    }

    .down_tit {
      font-size: 1.8rem;
      ${fontFamilyBold};
      margin-bottom: 2.4rem;
      padding: 4rem 4rem 0;
    }

    .accordion-down > div {
      display: inline-block;
      font-size: 1.2rem;
    }

    .down-info {
      color: #7783A1;

      span {
        ${fontFamilyRegular}
      }
    }

    .down-info span:after {
      content: '';
      width: .1rem;
      height: 1.5rem;
      background: #C7D6EA;
      margin: 0 .5rem;
      display: inline-block;
      vertical-align: middle;
    }

    .down-info span:last-child:after {
      display: none;
    }

    .down-info span b {
      color: #407EDB;
      font-weight: normal !important;
      margin-left: .5rem;
    }
  }

  .Result-bt {
    padding: 2.4rem 0;
    background: #F7F8FB;
    border-top: solid 1px #C7D6EA;
    display: flex;
    justify-content: space-between;

    > div {
      width: 50%;
      padding: 0 4rem
    }

    > div + div {
      border-left: solid 1px #C7D6EA
    }
  }

  @media screen and (max-width: 764px) {
    .SsqEditor {
      padding: 0 16px 16px;
    }

    .download {
      .down_tit {
        padding: 16px 16px 0 !important;
        margin-bottom: 16px !important;
      }

      > div:last-child {
        padding: 0 16px 16px !important;
      }
    }

    .Result-bt {
      padding: 0;
      display: block;

      > div {
        width: 100%;
        padding: 24px 16px;
      }

      > div + div {
        border-top: solid 1px #C7D6EA;
        border-left: none;
      }
    }
  }
`;

const SolutionRelated = styled.div`
  + div {
    margin-top: 1.6rem;
  }

  .related_tit {
    font-size: 1.2rem;

    img {
      vertical-align: middle;
    }
  }

  .related_list {
    color: #407DD8;
    font-size: 1.2rem;

    > div {
      display: inline-block;
      line-height: 2.4rem;

      span {
        cursor: pointer;
      }

      .comma {
        color: #90A0B6;
        margin-right: .4rem;
      }
    }
  }

  .related_list.one-line > div {
    display: block;
  }

  //:first-child .related_list > div {
  //  display: block;
  //}
`;


//0914 -추가 시작

const BlogPagePopupTop = styled.div`

  .review-input.modify {
    padding: 2.2rem 2.4rem !important;
  }

  .view-header {
    width: 100%;
    border-bottom: .1rem solid #C7D6EA;
    margin-bottom: 3.5rem;
    padding: 0 1.6rem;
    position: relative;
  }

  .view-header-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: nowrap;
    //overflow-x: auto;
    height: 6.4rem;
  }

  .view-header-item::-webkit-scrollbar {
    display: none;
  }

  .v-header-left {
    flex-shrink: 0;
  }

  .v-header-right {
    flex-shrink: 0;
    position: relative;
    display: flex;
    align-items: center;
  }

  .btn-list-modify {
    width: 2rem;
    height: 2rem;
    background-image: url("${SsqImages.community.icon.communitySpotMore}");
    background-repeat: no-repeat;
    background-position: center;
    position: relative;
    display: block;
  }

  .modify-item-body {
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);
    width: 80px;
    position: absolute;
    right: 0.8rem;
    top: 4.8rem;
    z-index: 2;
    display: none;
  }

  .modify-btn {
    color: #2A2C2F;
    ${fontFamilyMedium};
    font-size: 12px;
    width: 80px;
    height: 48px;
    line-height: 48px;
  }

  .modify-btn:first-child {
    border-radius: 4px 4px 0 0;
    background: #fff;
  }

  .modify-btn:last-child {
    border-radius: 0 0 4px 4px;
    border-top: 1px solid #C7D6EA;
    background: #fff;
  }

  .modify-btn.notify {
    border-radius: .4rem;
    border: none;
  }
`;

//제목 상단의 태그 css
const BlogPagePopupTitleTag = styled.div`



  .view-content .view-content-tag ul li {
    ${fontFamilyRegular};
    font-size: 1.2rem;
    color: #7783A1;
    display: inline-block;
    margin-right: 1.2rem;
    margin-bottom: 1rem;
  }

  .view-content .view-content-tag ul > li.blog-type {
    ${fontFamilyMedium};
    display: inline-block;
  }

  .view-content .view-content-tag ul > li.type {
    margin-right: 1.8rem;
  }

  .view-content .view-content-tag ul > li.doc-type.tip {
    font-size: 1.2rem;
    margin-right: 1rem;
    font-weight: 500;
    line-height: 1.6;
    width: 5rem;
    text-align: center;
    border-radius: 1rem;
    background: #34a597;
    color: #fff;
  }

  .view-content .view-content-tag ul > li.doc-type.doc_evt {
    font-size: 1.2rem;
    margin-right: 1rem;
    font-weight: 500;
    line-height: 1.6;
    width: 5rem;
    text-align: center;
    border-radius: 1rem;
    background: #407EDB;
    color: #fff;
  }

  .view-content .view-content-tag ul > li.doc-type.doc_noti {
    font-size: 1.2rem;
    margin-right: 1rem;
    font-weight: 500;
    line-height: 1.6;
    width: 5rem;
    text-align: center;
    border-radius: 1rem;
    background: #407EDB;
    color: #fff;
  }

  .view-content .view-content-tag ul > li.doc-type.job_offer {
    font-size: 1.2rem;
    margin-right: 1rem;
    font-weight: 500;
    line-height: 1.6;
    width: 5rem;
    text-align: center;
    border-radius: 1rem;
    background: #756CD9;
    color: #fff;
  }

  .view-content .view-content-tag ul > li.doc-type.job_search {
    font-size: 1.2rem;
    margin-right: 1rem;
    font-weight: 500;
    line-height: 1.6;
    width: 5rem;
    text-align: center;
    border-radius: 1rem;
    background: #756CD9;
    color: #fff;
  }

`;


//페이지 전체 css
const BlogPagePopupMain = styled.div`

  ul.comment-box {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    /* margin-top: 1rem; */
  }

  ul.comment-box.solution-profile {
    display: flex;
    margin-top: 2rem;
    display: none;
  }

  ul.comment-box > li {
    margin-right: .6rem;
    font-size: 1.2rem;
    color: #7783A1;
    font-weight: 500;
    flex-shrink: 0;
    position: relative;
  }

  .v-header-right ul.comment-box > li {
    margin-right: 1.6rem;
  }

  .v-header-left ul.comment-box > li {
    margin-right: .6rem;
  }

  ul.comment-box .c-txt {
    height: 1.8rem;
    line-height: 1.8rem;
    padding: 0 1rem;
    font-size: 1rem;
    border-radius: 2rem;
  }

  ul.comment-box .c-name {
    color: #2A2C2F;
    font-size: 1.3rem;
  }

  ul.comment-box .c-name span:first-child {
    width: 3.2rem;
    height: 3.2rem;
    display: inline-block;
    vertical-align: middle;
    border: 1px solid #F7B91B;
    border-radius: 100%;
    overflow: hidden;
    margin-right: .4rem;
    font-size: 1.6rem;
    line-height: 3rem;
  }

  ul.comment-box .c-name span:last-child {
    vertical-align: middle;
    line-height: 3.2rem;
  }

  ul.comment-box .c-name span img {
    width: 100%;
    height: 100%;
  }

  ul.comment-box .c-name span.unknown {
    border: none;
  }

  ul.comment-box .c-time {
    background-image: url("${SsqImages.community.icon.communityTime()}");
    background-repeat: no-repeat;
    background-position: left center;
    background-size: 1.6rem;
    padding-left: 1.8rem;
    ${fontFamilyRegular};
  }

  ul.comment-box .c-view {
    color: #407EDB;
    background-image: url("${SsqImages.community.icon.communityView()}");
    background-repeat: no-repeat;
    background-position: left center;
    background-size: 1.6rem;
    padding-left: 1.8rem;
    ${fontFamilyRegular};
  }

  ul.comment-box .c-good {
    color: #407EDB;
    background-image: url("${SsqImages.community.icon.communityGood24()}");
    background-repeat: no-repeat;
    background-position: left center;
    padding-left: 1.8rem;
  }

  ul.comment-box .c-not-bad {
    color: #FF215D;
    background-image: url("${SsqImages.community.icon.communityNotBad24()}");
    background-repeat: no-repeat;
    background-position: left center;
    padding-left: 1.8rem;
  }

  ul.comment-box .view-like {
    height: 2.4rem;
    line-height: 2.4rem;
    background-image: url("${SsqImages.community.icon.communityGood24()}");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: left center;
    padding-left: 2.8rem;
    color: #407EDA;
    ${fontFamilyRegular};
  }

  ul.comment-box .view-like.on {
    background-image: url("${SsqImages.community.icon.communityGoodOn24()}");
    background-repeat: no-repeat;
    background-position: left center;
  }

  ul.comment-box .view-bad {
    height: 2.4rem;
    line-height: 2.4rem;
    background-image: url("${SsqImages.community.icon.communityNotBad24()}");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: left center;
    padding-left: 2.8rem;
    color: #FF215D;
    ${fontFamilyRegular};
  }

  ul.comment-box .view-bad.on {
    background-image: url("${SsqImages.community.icon.communityNotBadOn24()}");
    background-repeat: no-repeat;
    background-position: left center;
  }

  ul.comment-box .view-bookmark {
    width: 2.4rem;
    height: 2.4rem;
    line-height: 2.4rem;
    background-image: url("${SsqImages.community.icon.communityBookmark()}");
    background-repeat: no-repeat;
    background-position: center;
    display: block;
  }

  ul.comment-box .view-bookmark.on {
    background-image: url("${SsqImages.community.icon.communityBookmarkOn()}");
    background-repeat: no-repeat;
    background-position: left center;
  }

  ul.comment-box .view-share {
    width: 2.4rem;
    height: 2.4rem;
    line-height: 2.4rem;
    background-image: url("${SsqImages.common.icon.shareImg()}");
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
  }

  .community-view {
    width: 100%;
    height: 100%;
    min-height: 90rem;
    background: rgb(238, 241, 246);
    position: relative;
    //top: 6rem;
  }

  .view-container {
    padding: 3.2rem 0 4rem;
  }

  .community__content {
    position: relative;
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    gap: 40px
  }

  .community__content div > .content {
    background: rgb(255, 255, 255);
    box-shadow: rgb(0 0 0 / 10%) 0px 4px 10px;
    border-radius: 4px;
    width: 84rem;
  }

  /*----- 오른쪽 내용  aside  시작 -----*/

  aside.community-view-aside {
    width: 32.8rem;
  }

  .aside-content {
    position: fixed;
    height: 65%;
    width: 30rem;
    overflow-y: auto;

    > div {
      height: auto;
      min-height: 100%;
      display: flex;
      flex-direction: column;

      .solution-list {
        height: 100%;
        width: 100%;
        flex: 1;
        padding-bottom: 10rem;
      }
    }
  }

  /*----- 오른쪽 내용  aside  끝 -----*/

  .view-content {
    padding: 0 4rem;
    min-height: 50rem
  }


  .view-footer {
    border-top: 1px dashed #ddd;
  }

  .v-header-left .blog-type-info {
    display: none;
  }

  .commu_bottom_cont {
    display: flex;
    width: 100%;
    justify-content: space-between;

    > div {
      width: 100%;
    }
  }


  /*----------------------------------------*/
  /*---------- 타블렛 모바일 공통 ----------*/
  /*----------------------------------------*/

  @media screen and (max-width: 1199px) {

    .view-container {
      padding-top: 0;
    }

    .SsqEditor img {
      height: auto;
      margin: 35px 0px;
      max-width: 100% !important;
    }

    .aside-content {
      position: relative;
      height: auto;
      width: 100%;
      overflow-y: auto;
      padding: 0 3rem;
    }

    aside.community-view-aside {
      width: 100%;
    }

    aside .solution-list {
      display: none;
    }

    .community__content > .content {
      width: 100%;
    }

    .community__content {
      flex-wrap: wrap;
    }

    .community__content > div {
      width: 100%;
    }

    .community__content div > .content {
      width: 100%;
    }

    .review-input.on {
      padding: 2.2rem 2.4rem !important;
    }
  }


  /*----------------------------------------*/
  /*---------- 모바일 사이즈 ----------*/
  /*----------------------------------------*/

  @media screen and (max-width: 764px) {

    .view-content {
      padding: 0 1.6rem;
    }

    .mobile-black {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 9;
      background: rgba(0, 0, 0, .5);
      display: none;
    }

    .community__content > div {
      width: 100%;
    }

    .community__content div > .content {
      width: 100%;
    }

    .view-outer {
      border-bottom: 1px solid #C7D6EA;
      padding: 0 3rem 3rem !important;
    }

    .SsqEditor img {
      height: auto;
      margin: 35px 0px;
      /* max-width: 100% !important; */
    }

    .SsqEditor {
      overflow-x: auto;
    }

    .SsqEditor table {
      max-width: 100%;
      table-layout: fixed;
      word-break: break-word;
      width: 100% !important;
    }

    /*-- 상단에 나오는 수정화면과, 끝부분 댓글에 나오는 화면을 같이 쓰는 부분 --*/
    .modify-item-body {
      width: 90%;
      position: fixed;
      left: 50%;
      top: 50%;
      max-width: 20rem;
      transform: translate(-50%, -50%);
      z-index: 101;
    }

    .modify-btn {
      width: 100%;
      max-width: 20rem;
    }

    .v-header-left {
      margin-right: 4rem;
    }

    .view-content .view-content-tag {
      padding: 0 1.6rem
    }

    .v-header-left .comment-box {
      display: none;
    }

    .v-header-left .blog-type-info {
      color: #7783A1;
      font-size: 1.2rem;
      line-height: 1.8rem;
      padding-left: 1.6rem;
      display: block;
    }

    .view-content .view-content-tag ul li.blog-type {
      display: none
    }

    ul.comment-box.solution-profile {
      display: flex;
      flex-wrap: wrap;
    }

    .commu_bottom_cont {
      flex-direction: column;
    }

    /*-- 상단에 나오는 수정화면과, 끝부분 댓글에 나오는 화면을 같이 쓰는 부분 --*/
  }
`;

const BlogPageAside = styled.div`

  /*하단 피드백 부분 시작*/


`;


const BlogPageFooter = styled.div`

  /*다운로드 부분*/

  .content-download {
    padding: 4rem
  }

  .content-download > p.title {
    color: #2A2C2F;
    font-size: 1.8rem;
    ${fontFamilyBold}
  }

  .content-download > ul.down-list {
    //margin-top: 2.4rem;
  }


  .content-download > ul.down-list .down-icon {
    position: relative;
  }

  .content-download > ul.down-list > li {
    margin-top: 1rem;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  .content-download > ul.down-list li button.down-title {
    color: #407EDB;
    ${fontFamilyMedium};
    font-size: 1.3rem;
    padding-right: 0.7rem;
      //background-image: url("${SsqImages.common.icon.downloadImg}");
    background-repeat: no-repeat;
    background-position: right center;
  }

  .down-title {
    > a {
      color: #407EDB;
      font-size: 1.6rem;
    }
  }

  .content-download > ul.down-list li ul.file-info {
    display: flex;
    margin-left: .4rem;
  }

  .content-download > ul.down-list li ul.file-info li {
    ${fontFamilyMedium};
    font-size: 1.2rem;
    color: #7783A1;
    border-right: 1px solid #C7D6EA;
    padding: 0 .6rem;
  }

  .content-download > ul.down-list li ul.file-info li:last-child {
    border: none;
  }

  .content-download > ul.down-list li ul.file-info li > span.count {
    color: #407EDB;
    margin-left: .4rem;
  }

  @media screen and (max-width: 764px) {
    .content-download > ul.down-list li ul.file-info {
      margin-left: -0.6rem;
      margin-top: .4rem;
    }
  }

  /*하단 댓글*/

  .review-content {
    //padding: .8rem 0;
    background: #F7F8FB;
  }

  .review-content:first-child {
    border-top: .1rem solid #EEF1F6;
    padding-top: .8rem;
  }

  .review-content-item {

  }

  .inner-review-modify {
    width: 100%;
    margin-top: 0.5rem;
  }

  .review-flex {
    display: flex;
    flex-wrap: wrap;
    /* align-items: center;                 */
    //padding: .8rem 2.4rem;
  }

  .review-flex > .left {
    flex-shrink: 0;
  }

  .review-flex > .right {
    //padding-top: 0.6rem;
    padding: 1rem 2.4rem;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  .review-flex > .right > .comment-wrap {
    display: inline-block;
  }

  .review-flex > .right > .comment-wrap > li {
    display: inline-block;
  }

  .comment-content {
    margin-right: 1rem;
    ${fontFamilyRegular};
    font-size: 1.3rem;
    color: #2A2C2F;
    line-height: 2.4rem;
    white-space: pre-wrap;
  }

  .review-flex .right .comment-content {
    order: 1;
    width: 100%;
    margin-right: 0;
  }

  .review-flex > .right > .list-modify-body {
    position: relative;
    //vertical-align: middle;
    //display: inline-block;
    padding-bottom: 0.2rem;
  }

  .review-flex .comment-wrap > li {
    margin-right: .6rem;
  }

  .right > .list-modify-body > .modify-item-body {
    top: 2.8rem;
    display: none;
  }

  @media screen and (max-width: 764px) {
    .right > .list-modify-body > .modify-item-body {
      top: 50%;
    }

    .review-content {
      //padding: .8rem 0 0;
    }

    .review-flex .right {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
    }

    .review-flex .right .comment-box {
      order: 0;
    }

    .review-flex .right .comment-content {
      order: 1;
      width: 100%;
      margin-right: 0;
    }

    .btn-list-modify {
      vertical-align: middle;
    }

    .review-input.on {
      padding: 2.2rem 2.4rem !important;
    }

    .review-input > textarea {
      ${fontFamilyRegular};
      font-size: 16px;

      transform: scale(0.81);
      transform-origin: left;
    }

    .review-input > textarea::placeholder {
      color: #90A0B6;
      font-size: 1.7rem;
    }
  }

  /*댓글 작성*/

  .review-flex .right {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }


  .review-input {
    padding: 0 0 0 2.4rem;
    display: flex;
    align-items: center;
    border-top: 1px solid #EEF1F6;
    background: #fff;
  }

  .review-input > textarea {
    width: calc(100% - 5rem);
    margin-right: 1rem;
    ${fontFamilyRegular};

    ::-webkit-scrollbar {
      display: none;
    }
  }

  .review-input > textarea::placeholder {
    color: #90A0B6;
  }

  button.ent {
    width: 6.4rem;
    height: 6.4rem;
    background-position: 50%;
    background-image: url("${SsqImages.boris.CommentsBtn()}");
    background-repeat: no-repeat;
    align-self: flex-end;
  }

  button.review-del {
    width: 2.4rem;
    height: 2.4rem;
    background: url("${SsqImages.community.icon.communityReviewDel()}") no-repeat;
    margin-right: 1.6rem;
    align-self: flex-end;
  }

  button.review-enter {
    width: 2.4rem;
    height: 2.4rem;
    background: url("${SsqImages.community.icon.communityReviewEnter()}") no-repeat;
    flex-shrink: 0;
    align-self: flex-end;
  }

`;

const BlogPageFooterCategory = styled.div`

  .view-outer {
    display: flex;
  }

  .view-outer .view-outer-left {
    width: 50%;
  }

  .view-outer .view-outer-right {
    width: 50%
  }

  .conn-category {
    margin-top: 3.2rem;
  }

  .conn-category > .title {
    color: #2A2C2F;
    font-size: 1.2rem;
    ${fontFamilyMedium};
    line-height: 2.4rem;
  }

  .conn-category > .title > span.link-icon {
    height: 2.4rem;
    background-image: url("${SsqImages.product.linkicon}");
    background-repeat: no-repeat;
    background-position: right center;
    display: inline-block;
    padding-right: 2.6rem;
  }

  .conn-category > ul li {
    margin-top: .8rem;
  }

  .conn-category > ul li > a {
    ${fontFamilyMedium};
    color: #407DD8;
    font-size: 1.2rem;
  }

  @media screen and (max-width: 1199px) {
    .view-outer {
      padding: 0 3rem;
      flex-wrap: wrap;
    }

    .view-outer .view-outer-left {
      width: 100%;
    }

    .view-outer .view-outer-right {
      width: 100%
    }
  }

`;
``;
